webpackJsonp([1],Array(150).concat([
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modals_RainAlertModal_vue__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_WavesAlertModal_vue__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modals_WindAlertModal_vue__ = __webpack_require__(391);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import geolib from 'geolib'
// import { mapActions } from 'vuex'




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    RainAlertModal: __WEBPACK_IMPORTED_MODULE_0__components_modals_RainAlertModal_vue__["a" /* default */],
    WavesAlertModal: __WEBPACK_IMPORTED_MODULE_1__components_modals_WavesAlertModal_vue__["a" /* default */],
    WindAlertModal: __WEBPACK_IMPORTED_MODULE_2__components_modals_WindAlertModal_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isAddedHome: false,
      alertCardModal: false
    };
  },
  name: 'app',
  mounted: function mounted() {
    var _this = this;

    if (window.screen.height - window.innerHeight > 80) {
      this.isAddedHome = false;
    } else {
      this.isAddedHome = true;
    }
    this.$store.state.showModal = false;

    var OneSignal = window.OneSignal || [];
    OneSignal.push(function () {
      OneSignal.init({
        appId: "92cf6e5c-6c24-45d0-a6ff-dccfa4db6adb",
        autoResubscribe: true,
        allowLocalhostAsSecureOrigin: true,
        welcomeNotification: {
          title: 'Coastal Live',
          message: 'We will keep you posted!'
        },
        promptOptions: {},
        notifyButton: {
          enable: false
        }
      });
      OneSignal.on('subscriptionChange', function (isSubscribed) {
        if (isSubscribed) {
          OneSignal.getUserId(function (userId) {
            _this.$axios.post('/auth/notificationuserid', {
              key: userId
            });
          });
        }
      });
    });
  },
  methods: {
    homeScreen: function homeScreen() {
      this.isAddedHome = true;
    }
  },
  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    bodyClasses: function bodyClasses() {
      var classes = this.$route.name.toLowerCase() + 'Screen';
      if (this.user && this.user.profile && this.user.profile.dark_mode === 1) {
        classes += ' darkmode';
      }
      return classes;
    },
    showModal: function showModal() {
      return this.$store.state.showModal;
    }
  }
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    closeModal: function closeModal(type) {
      document.body.classList.remove('alertModalOpen');
      this.$store.state.showModal = false;
    }
  }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    closeModal: function closeModal(type) {
      document.body.classList.remove('alertModalOpen');
      this.$store.state.showModal = false;
    }
  }
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    closeModal: function closeModal(type) {
      document.body.classList.remove('alertModalOpen');
      this.$store.state.showModal = false;
    }
  }
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_home_HomeCardList__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_home_HomeWeather__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_HomeFilterButtons_vue__ = __webpack_require__(296);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: {
    HomeCardList: __WEBPACK_IMPORTED_MODULE_0__components_home_HomeCardList__["a" /* default */],
    HomeWeather: __WEBPACK_IMPORTED_MODULE_1__components_home_HomeWeather__["a" /* default */],
    FilterButtons: __WEBPACK_IMPORTED_MODULE_2__components_home_HomeFilterButtons_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.$store.dispatch('getAlert');
    document.body.classList.remove('scrolled');
    document.getElementById('cards').scrollTop = 0;
  },
  data: function data() {
    return {
      showForecast: false,
      scrollPosition: 0
    };
  },
  methods: {
    toggleForecast: function toggleForecast() {
      this.showForecast = !this.showForecast;
    },
    handleScroll: function handleScroll(e) {
      var currentScrollPosition = e.srcElement.scrollTop;
      if (currentScrollPosition > 20) {
        document.body.classList.add('scrolled');
        this.showForecast = false;
      } else {
        document.body.classList.remove('scrolled');
      }
      this.scrollPosition = currentScrollPosition;
    },
    scrollTop: function scrollTop(e) {
      document.getElementById('cards').scrollTop = 0;
    }
  }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_infinite_loading__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HomeCardListItem__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cards_Custom__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cards_Interests__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cards_Alert__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__profile_Profile__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(15);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_1_vue_infinite_loading___default.a,
    HomeCardListItem: __WEBPACK_IMPORTED_MODULE_2__HomeCardListItem__["a" /* default */],
    CustomCard: __WEBPACK_IMPORTED_MODULE_3__cards_Custom__["a" /* default */],
    InterestCard: __WEBPACK_IMPORTED_MODULE_4__cards_Interests__["a" /* default */],
    AlertCard: __WEBPACK_IMPORTED_MODULE_5__cards_Alert__["a" /* default */],
    ProfileCard: __WEBPACK_IMPORTED_MODULE_6__profile_Profile__["a" /* default */]
  },
  data: function data() {
    return {
      currentPage: 1,
      nextPage: 1,
      lastPage: 1,
      cardsData: [],
      infiniteId: +new Date(),
      showinterests: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["d" /* mapState */])({
    user: function user(state) {
      return state.user;
    },
    alerts: function alerts(state) {
      return state.alert;
    }
  })),
  mounted: function mounted() {
    if (this.user && (this.user !== undefined ? this.user.interests.length : 0) < 1) {
      this.showinterests = true;
    }
  },
  methods: {
    infiniteHandler: function infiniteHandler($state) {
      var _this = this;

      // console.log('Load more cards')
      this.$store.dispatch('getCards', this.nextPage).then(function (response) {
        if (response.status === 200 && response.data.data.length) {
          _this.currentPage = _this.nextPage;
          _this.nextPage = _this.currentPage + 1;
          _this.lastPage = response.data.last_page;
          _this.cardsData = _this.cardsData.length > 0 ? _this.cardsData.concat(response.data.data) : response.data.data;
          $state.loaded();
        } else {
          $state.complete();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    checkInterests: function checkInterests() {
      return this.state.user !== undefined ? this.state.user.interests.length : 0;
    }
  }
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cards_Article__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cards_Photo__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cards_Tweet__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cards_Camera__ = __webpack_require__(416);
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['card'],
  components: {
    ArticleCard: __WEBPACK_IMPORTED_MODULE_0__cards_Article__["a" /* default */],
    PhotoCard: __WEBPACK_IMPORTED_MODULE_1__cards_Photo__["a" /* default */],
    TweetCard: __WEBPACK_IMPORTED_MODULE_2__cards_Tweet__["a" /* default */],
    CameraCard: __WEBPACK_IMPORTED_MODULE_3__cards_Camera__["a" /* default */]
  },
  computed: {
    cardType: function cardType() {
      return this.card.type;
    },
    filter: function filter() {
      return this.$store.getters.filter;
    },
    articleCard: function articleCard() {
      if (this.filter === 'all' || this.filter === 'news') {
        return this.card.type === 'news';
      }
      return false;
    },
    photoCard: function photoCard() {
      if (this.filter === 'all' || this.filter === 'social') {
        return this.card.type === 'flickr';
      }
      return false;
    },
    tweetCard: function tweetCard() {
      if (this.filter === 'all' || this.filter === 'weather' || this.filter === 'social') {
        if (this.filter === 'weather') {
          return this.card.tags === 'SAWeatherServic';
        }
        return this.card.type === 'twitter' && this.card.tags !== 'SAWeatherServic';
      }
      return false;
    },
    cameraCard: function cameraCard() {
      if (this.filter === 'all') {
        return this.card.type === 'camera';
      }
      return false;
    },
    userInterests: function userInterests() {
      if (this.$store.getters.user) {
        return this.$store.getters.user.interests.map(function (interest) {
          return interest.name.toLowerCase();
        });
      }

      return null;
    },
    showArticle: function showArticle() {
      var _this = this;

      if (this.articleCard || this.photoCard || this.tweetCard || this.cameraCard) {
        if (this.card.type !== 'news' || this.userInterests === null) {
          return true;
        }
        return this.userInterests.filter(function (value) {
          return _this.card.tags.includes(value);
        }).length > 0;
      }
      return false;
    }
  },
  mounted: function mounted() {
    // console.log(this.card)
  }
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'article-card',
  props: {
    cardData: {
      type: Object,
      default: null
    }
  },
  computed: {
    bgImage: function bgImage() {
      return 'background-image: url(' + this.cardData.json_object.urlToImage + ');';
    },
    articleImage: function articleImage() {
      return this.cardData.json_object.urlToImage;
    },
    whenDate: function whenDate() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.cardData.created_at).format('DD MMM YYYY');
    }
  },
  mounted: function mounted() {},
  methods: {
    openArticle: function openArticle() {
      window.open(this.cardData.json_object.url, '_blank');
    }
  }
});

/***/ }),
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'photo-card',
  props: {
    cardData: {
      type: Object,
      default: null
    }
  },
  computed: {
    bgImage: function bgImage() {
      return 'background-image: url(' + this.cardData.json_object.url_m + ');';
    },
    whenDate: function whenDate() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.cardData.created_at).fromNow();
    }
  },
  mounted: function mounted() {
    // console.log('Photo of the Day')
    // console.log(this.cardData)
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tweet-card',
  data: function data() {
    return {
      cardImage: false
    };
  },

  props: {
    cardData: {
      type: Object,
      default: null
    }
  },
  computed: {
    bgImage: function bgImage() {
      return this.cardData.json_object.user.profile_image_url_https;
    },
    cardImageUrl: function cardImageUrl() {
      return this.cardData.json_object.extended_entities.media[0].media_url_https;
    },
    whenDate: function whenDate() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.cardData.json_object.created_at, 'ddd MMM D HH:mm:ss Z YYYY').fromNow();
    }
  },
  mounted: function mounted() {
    if (this.cardData.json_object.extended_entities != null) {
      this.cardImage = true;
    }
  },
  methods: {}
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'camera-card',
  props: ['cardData'],
  computed: {
    storageUrl: function storageUrl() {
      return this.$store.getters.storageEndpoint;
    },
    cameraUrl: function cameraUrl() {
      return this.storageUrl + 'cameras/' + this.cardData.json_object.filename;
    },
    bgcssdata: function bgcssdata() {
      return { 'background-image': 'url("' + this.cameraUrl + '")' };
    }
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'custom-card'
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Interests_vue__ = __webpack_require__(291);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3602c14e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Interests_vue__ = __webpack_require__(423);
function injectStyle (ssrContext) {
  __webpack_require__(422)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3602c14e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Interests_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3602c14e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Interests_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'interests-card',
  data: function data() {
    return {
      selectedInterests: []
    };
  },

  computed: {
    interests: function interests() {
      return this.$store.getters.interests;
    },
    user: function user() {
      return this.$store.getters.user;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.dispatch('getInterests').then(function (response) {
      _this.$nextTick(function () {
        this.populateselectedInterests();
      });
    });
  },
  methods: {
    interestName: function interestName(interest) {
      return interest.name;
    },
    interestId: function interestId(interest) {
      return interest.id;
    },
    populateselectedInterests: function populateselectedInterests() {
      var _this2 = this;

      var userInterests = this.user.interests;
      if (userInterests.length > 0 && this.interests.length > 0) {
        userInterests.forEach(function (userInterest) {
          _this2.interests.forEach(function (interest) {
            if (userInterest.id === interest.id) {
              var index = _this2.selectedInterests.indexOf(interest.id);
              if (index === -1) {
                _this2.selectedInterests.push(interest.id);
              }
            }
          });
        });
      }
    },
    checkInterest: function checkInterest(interest) {
      if (this.selectedInterests.length > 0) {
        var index = this.selectedInterests.indexOf(interest.id);
        if (index > -1) {
          return true;
        }
      }
      return false;
    },
    addToSelectedOrRemoveFromSelected: function addToSelectedOrRemoveFromSelected(interest) {
      var index = this.selectedInterests.indexOf(interest.id);
      if (index > -1) {
        this.selectedInterests.splice(index, 1);
      } else {
        this.selectedInterests.push(interest.id);
      }
      this.updateUserInterests();
    },
    updateUserInterests: function updateUserInterests() {
      var _this3 = this;

      window.alertify.dismissAll();
      this.$store.dispatch('updateUserInterests', {
        'interests': this.selectedInterests
      }).then(function (response) {
        _this3.$nextTick(function () {
          window.alertify.success('Interests saved!');
          this.populateselectedInterests();
          this.$store.dispatch('getCards');
        });
      });
    }
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'alert-card',
  props: ['alert'],
  data: function data() {
    return {
      tipsopen: false,
      tooltipOpen: false,
      modelOpen: false
    };
  },
  methods: {
    tipsOpen: function tipsOpen() {
      this.tipsopen = !this.tipsopen;
    },
    openTooltip: function openTooltip() {
      this.tooltipOpen = !this.tooltipOpen;
      // document.body.addEventListener('click', () => {
      //   this.tooltipOpen = false
      // }, true)
    },
    openSource: function openSource(url) {
      window.open(url);
    },
    showAlertModal: function showAlertModal(type) {
      document.body.classList.add('alertModalOpen');
      this.$store.state.showModal = type;
      console.log(this.$store.state.modelOpen);
    }
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(294);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56b0f089_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(428);
function injectStyle (ssrContext) {
  __webpack_require__(427)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56b0f089"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56b0f089_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cards_Interests__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(15);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profile-card',
  components: {
    InterestCard: __WEBPACK_IMPORTED_MODULE_1__cards_Interests__["a" /* default */]
  },
  props: {
    user: Object,
    regions: Array
  },
  data: function data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    updateUnitWind: function updateUnitWind(v) {
      this.user.profile.unit_wind = v;
      this.updateProfile();
    },
    updateUnitTemperature: function updateUnitTemperature(v) {
      this.user.profile.unit_temperature = v;
      this.updateProfile();
    },
    updateProfile: function updateProfile() {
      var _this = this;

      document.getElementById('app').classList.add('loading');
      var updateProfile = {
        name: this.user.name,
        weather_region_id: this.user.profile.weather_region_id,
        dark_mode: this.user.profile.dark_mode,
        notification_high_rainfall: this.user.profile.notification_high_rainfall,
        notification_daily_weather_update: this.user.profile.notification_daily_weather_update,
        unit_wind: this.user.profile.unit_wind,
        unit_temperature: this.user.profile.unit_temperature
      };
      this.updateUserInfo(updateProfile).then(function (response) {
        if (_this.user.profile.notification_daily_weather_update === 1 || _this.user.profile.notification_high_rainfall === 1) {
          _this.oneSignalNotificationUpdate();
        }
        document.getElementById('app').classList.remove('loading');
        window.alertify.dismissAll();
        window.alertify.success('Settings Saved.');
      });
    },
    oneSignalNotificationUpdate: function oneSignalNotificationUpdate() {
      var _this2 = this;

      var OneSignal = window.OneSignal;
      OneSignal.push(function () {
        OneSignal.registerForPushNotifications();
        OneSignal.setSubscription(true).then(function () {
          OneSignal.getUserId(function (userId) {
            _this2.$axios.post('/auth/notificationuserid', {
              key: userId
            });
          });
        });
      });
    },
    updateInterests: function updateInterests() {},
    logout: function logout() {
      this.removeJWT();
      this.$router.push('/');
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapMutations */])(['removeJWT']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['updateUserInfo']))
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HomeFilterButtons_vue__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_geolib__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_geolib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_geolib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HomeForecast__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(15);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['showForecast', 'toggleForecast'],
  components: {
    HomeForecast: __WEBPACK_IMPORTED_MODULE_3__HomeForecast__["a" /* default */],
    FilterButtons: __WEBPACK_IMPORTED_MODULE_1__HomeFilterButtons_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])({
    allWeather: function allWeather(state) {
      return state.weather;
    },
    user: function user(state) {
      return state.user;
    }
  }), {
    currentWeather: function currentWeather() {
      return this.allWeather.data ? this.allWeather.data[0] : null;
    },
    isUserLoggedOut: function isUserLoggedOut() {
      return this.$store.getters.isUserLoggedOut;
    },
    isTokenExpired: function isTokenExpired() {
      return this.$store.getters.isTokenExpired;
    },
    user: function user() {
      return this.$store.getters.user;
    },
    weatherRegions: function weatherRegions() {
      return this.$store.getters.weatherRegions;
    },
    calculateTemp: function calculateTemp() {
      if (this.user && this.user.profile.unit_temperature === 'F') {
        this.tempType = 'F';
        return this.conversionCToF(this.currentWeather.json_object.main.temp);
      } else {
        this.tempType = 'C';
        return Math.round(this.currentWeather.json_object.main.temp);
      }
    },
    calculateWind: function calculateWind() {
      if (this.user && this.user.profile.unit_wind === 'kn') {
        this.windType = 'kn';
        return this.conversionKmHToKn(this.windSpeed(this.currentWeather.json_object.wind.speed));
      } else {
        this.windType = 'km/h';
        return this.windSpeed(this.currentWeather.json_object.wind.speed);
      }
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.$store.dispatch('getWeatherRegions').then(function (response) {
      if (!_this.isUserLoggedOut) {
        _this.$store.dispatch('getUserInfo').then(function (response) {
          _this.$store.dispatch('getWeatherData', _this.$store.state.user.profile.weather_region_id);
        });
      } else {
        if (navigator.geolocation) {
          _this.geolocation();
        } else {
          console.log('Not available geolocation');
          _this.$store.dispatch('getWeatherData', 1);
        }
      }
    });
  },
  data: function data() {
    return {
      tempType: 'C',
      windType: 'km/h'
    };
  },
  methods: {
    conversionCToF: function conversionCToF(temp) {
      return Math.round(temp * 1.8 + 32);
    },
    conversionKmHToKn: function conversionKmHToKn(wind) {
      return Math.round(wind / 1.852);
    },

    toggle: function toggle() {
      this.showForecast = !this.showForecast;
      document.body.classList.toggle('forecastShown');
    },
    populateWeatherIcon: function populateWeatherIcon(weather) {
      return '/static/img/weather/' + weather[0].icon + '.svg';
    },

    windSpeed: function windSpeed(speed) {
      return Math.round(speed * 3.6);
    },
    getRegions: function getRegions() {
      var regions = {};
      this.weatherRegions.forEach(function (element) {
        regions[element.id] = {
          latitude: element.latitude,
          longitude: element.longitude
        };
      });
      // console.log(regions)
      return regions;
    },
    geolocation: function geolocation() {
      navigator.geolocation.getCurrentPosition(this.buildUrl, this.geoError);
    },
    buildUrl: function buildUrl(position) {
      var location = __WEBPACK_IMPORTED_MODULE_2_geolib___default.a.findNearest({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude
      }, this.getRegions(), 1);

      this.$store.dispatch('getWeatherData', location.key);
    },
    geoError: function geoError(error) {
      console.log(error);
      // Default back to Durban weather
      this.$store.dispatch('getWeatherData', 1);
    }
  }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeFilterButtons_vue__ = __webpack_require__(297);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27235306_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeFilterButtons_vue__ = __webpack_require__(433);
function injectStyle (ssrContext) {
  __webpack_require__(432)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27235306"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeFilterButtons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27235306_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeFilterButtons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'filter-buttons',
  computed: {
    filter: function filter() {
      return this.$store.getters.filter;
    }
  },
  mounted: function mounted() {
    // console.log('Filter Buttons')
  },
  methods: {
    updateFilter: function updateFilter(filter) {
      this.$store.commit('FILTER_UPDATED', filter);
    }
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home-forecast',
  props: ['forcasts', 'tempType'],
  computed: {},
  methods: {
    calculateTemp: function calculateTemp(temp) {
      if (this.tempType === 'F') {
        return this.conversionCToF(temp);
      } else {
        return Math.round(temp);
      }
    },
    conversionCToF: function conversionCToF(temp) {
      return Math.round(temp * 1.8 + 32);
    },
    populateWeatherIcon: function populateWeatherIcon(weather) {
      return '/static/img/weather/' + weather[0].icon + '.svg';
    },
    convertToBrowserTimeZone: function convertToBrowserTimeZone(date) {
      var utcDate = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc(date).toDate();
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(utcDate).local().format('ddd LT');
    }
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  data: function data() {
    return {
      loading: false
    };
  },
  methods: {
    setLoading: function setLoading(status) {
      this.loading = status;
    }
  }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(15);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'email-register',
  props: ['setloading'],
  data: function data() {
    return {
      emailform: {
        'name': '',
        'email': '',
        'password': ''
      }
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    emailRegister: function emailRegister() {
      var _this = this;

      var payload = {
        name: this.emailform.name,
        email: this.emailform.email,
        password: this.emailform.password
      };
      this.setloading(true);
      this.RegisterByEmail(payload).then(function (response) {
        _this.setloading(false);
        _this.getUserInfo().then(function (response) {
          _this.getWeatherData(_this.$store.state.user.profile.weather_region_id).then(function (response) {
            _this.$nextTick(function () {
              this.$router.push('/');
            });
          });
        });
      }).catch(function (error) {
        window.alertify.error('There was a problem with your registration. Please try again. (Error: ' + error.response.data.message + ')');
        _this.setloading(false);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['RegisterByEmail', 'getUserInfo', 'getWeatherData']))
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(15);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login-social',
  data: function data() {
    return {};
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    facebookLogin: function facebookLogin() {
      this.getFacebookLoginUrl().then(function (response) {
        window.location.href = response.data;
      });
    },
    googleLogin: function googleLogin() {
      this.getGoogleLoginUrl().then(function (response) {
        window.location.href = response.data;
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['getFacebookLoginUrl', 'getGoogleLoginUrl']))
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(15);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reset-password',
  data: function data() {
    return {
      email: '',
      token: '',
      sent: false,
      password: '',
      password_confirm: '',
      loading: false
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    resetWithToken: function resetWithToken() {
      var _this = this;

      this.loading = true;

      this.resetByToken({
        email: this.email,
        token: this.token,
        password: this.password
      }).then(function (response) {
        window.alertify.success('Password Updated.');
        _this.$router.push('/login');
      }).catch(function (error) {
        window.alertify.error(error.message);
        _this.sent = false;
        _this.loading = false;
        _this.token = '';
        _this.password = '';
        _this.password_confirm = '';
      });
    },
    resetAccount: function resetAccount() {
      var _this2 = this;

      console.log(this.$store);
      this.loading = true;
      this.resetByEmail(this.email).then(function (response) {
        _this2.sent = true;
        _this2.loading = false;
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['resetByEmail', 'resetByToken']))
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(15);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'email-login',
  props: ['setloading'],
  data: function data() {
    return {
      emailform: {
        'email': '',
        'password': ''
      }
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    emailLogin: function emailLogin() {
      var _this = this;

      var payload = {
        email: this.emailform.email,
        password: this.emailform.password
      };
      this.setloading(true);
      this.loginByEmail(payload).then(function (response) {
        _this.getUserInfo().then(function (response) {
          _this.getWeatherData(_this.$store.state.user.profile.weather_region_id).then(function (response) {
            _this.$nextTick(function () {
              this.setloading(false);
              window.alertify.success('Welcome back!');
              this.$router.push('/');
            });
          });
        });
      }).catch(function () {
        _this.setloading(false);
        window.alertify.error('There was a problem logging in. Please check your details and try again.');
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['loginByEmail', 'getUserInfo', 'getWeatherData']))
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(15);

//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login-google',
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var _this = this;

    console.log('Google Login Redirect');
    console.log(this.$route.query.code);
    if (this.$route.query.code) {
      this.getGoogleLoginUser(this.$route.query.code).then(function (response) {
        _this.getUserInfo().then(function (response) {
          _this.getWeatherData(_this.$store.state.user.profile.weather_region_id).then(function (response) {
            _this.$nextTick(function () {
              this.$router.push('/');
            });
          });
        });
      });
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['getGoogleLoginUser', 'getUserInfo', 'getWeatherData']))
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(15);

//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login-facebook',
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var _this = this;

    console.log('Facebook Login Redirect');
    console.log(this.$route.query.code);
    if (this.$route.query.code) {
      this.getFacebookLoginUser(this.$route.query.code).then(function (response) {
        _this.getUserInfo().then(function (response) {
          _this.getWeatherData(_this.$store.state.user.profile.weather_region_id).then(function (response) {
            _this.$nextTick(function () {
              this.$router.push('/');
            });
          });
        });
      });
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['getFacebookLoginUser', 'getUserInfo', 'getWeatherData']))
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function getImage(file) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var fReader = new FileReader();
    var img = document.createElement('img');

    fReader.onload = function () {
      img.src = fReader.result;
      resolve(img.src);
    };

    fReader.readAsDataURL(file);
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'report',
  data: function data() {
    return {
      'formFields': {
        'name': 'John Doe',
        'email': 'johndoe@mail.com',
        'message': 'Storm water issue on 3rd Street',
        'mobile_number': '0312661338',
        'issue': '',
        'image': ''
      },
      'response': {
        'message': null
      },
      'ui': {
        'sending': false
      }
    };
  },
  methods: {
    sendIssue: function sendIssue() {
      var _this = this;

      this.ui.sending = true;
      this.$axios.post('environmental-issue/report', this.formFields).then(function (response) {
        console.log(response);
        _this.ui.sending = false;
        window.alertify.success('Saved! Thank you for your report.');
        _this.$router.push('/');
      }).catch(function (error) {
        _this.ui.sending = false;
        _this.setMessage('We were unable to process your submission');
        window.alertify.error('Unable to process form');
        console.log(error);
      });
    },
    fileChange: function fileChange(name, files) {
      var _this2 = this;

      getImage(files[0]).then(function (base64Image) {
        _this2.formFields.image = base64Image;
      });
    },
    setMessage: function setMessage(msg) {
      var _this3 = this;

      this.response.message = msg;
      setTimeout(function () {
        _this3.response.message = null;
      }, 3000);
    }
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_leaflet__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_map_LIdwLeaflet__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_map_LWaveLeaflet__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_map_LVectorLeaflet__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_leaflet__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_map_CamsView__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_timers__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(15);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var thiscamicon = new __WEBPACK_IMPORTED_MODULE_5_leaflet___default.a.Icon({
  iconRetinaUrl: __webpack_require__(320),
  iconUrl: __webpack_require__(320),
  // shadowUrl: require('../../node_modules/leaflet/dist/images/marker-shadow.png'),
  iconSize: [31, 26]
});

var _usericon = new __WEBPACK_IMPORTED_MODULE_5_leaflet___default.a.Icon({
  iconRetinaUrl: __webpack_require__(321),
  iconUrl: __webpack_require__(321),
  iconAnchor: [16, 31],
  iconSize: [31, 31]
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mainlayermap',
  components: {
    LMap: __WEBPACK_IMPORTED_MODULE_1_vue2_leaflet__["LMap"],
    LTileLayer: __WEBPACK_IMPORTED_MODULE_1_vue2_leaflet__["LTileLayer"],
    LMarker: __WEBPACK_IMPORTED_MODULE_1_vue2_leaflet__["LMarker"],
    'l-idw-layer': __WEBPACK_IMPORTED_MODULE_2__components_map_LIdwLeaflet__["a" /* default */],
    'l-vector-layer': __WEBPACK_IMPORTED_MODULE_4__components_map_LVectorLeaflet__["a" /* default */],
    'l-wave-layer': __WEBPACK_IMPORTED_MODULE_3__components_map_LWaveLeaflet__["a" /* default */],
    CamsView: __WEBPACK_IMPORTED_MODULE_6__components_map_CamsView__["a" /* default */]
  },
  mounted: function mounted() {
    // Find the timeline for the current map
    var m = __WEBPACK_IMPORTED_MODULE_7_moment___default()();
    var roundDown = m.startOf('hour');
    var remainder = roundDown.hour() % 3;
    var dateTime = roundDown.subtract(remainder, 'hours');
    this.timeline.currentDate = dateTime.unix();
    this.timeline.startDate = dateTime.subtract(1, 'days').unix();
    this.timeline.endDate = dateTime.add(4, 'days').unix();

    if (this.$route.params.section) {
      this.setView(this.$route.params.section);
    }

    navigator.geolocation.getCurrentPosition(this.buildUrl, this.geoError);
  },
  data: function data() {
    return {
      zoom: 8,
      center: [-29.936914876574946, 31.070483922958378],
      url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      currentZoom: 8,
      currentCenter: [-29.936914876574946, 31.070483922958378],
      baseUrl: 'https://www.ncei.noaa.gov/thredds/wms/gfs-003-files/201810/20181016/gfs_3_20181016_1200_384.grb2?',
      ui: {
        currentView: 'wind'
      },
      timeline: {
        startDate: null,
        currentDate: null,
        endDate: null,
        continuous: false
      },
      rainfall: {
        data: [],
        options: {
          opacity: 0.3, cellSize: 0.25, exp: 1, max: 30
        },
        loading: true
      },
      userpin: {
        lat: null,
        long: null
      },
      wind: {
        data: [],
        options: {
          minVelocity: 0, // used to align color scale
          maxVelocity: 30, // used to align color scale
          particleWidth: 1,
          velocityScale: 0.005 // modifier for particle animations, arbitrarily defaults to 0.005
        },
        loading: true
      },
      wave: {
        data: [],
        options: {
          minVelocity: 0, // used to align color scale
          maxVelocity: 30, // used to align color scale
          velocityScale: 0.01, // modifier for particle animations, arbitrarily defaults to 0.005,
          particleWidth: 10
        },
        loading: true
      },
      selectedCamera: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    currentTimeStamp: function currentTimeStamp() {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.timeline.currentDate, 'X').format('ddd hA');
    },
    cams: function cams() {
      return this.$store.state.cameras;
    },
    camicon: function camicon() {
      return thiscamicon;
    },
    usericon: function usericon() {
      return _usericon;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["d" /* mapState */])({
    user: function user(state) {
      return state.user;
    }
  })),
  watch: {
    'timeline.currentDate': function timelineCurrentDate(newTime) {
      var _this = this;

      this.rainfall.loading = true;
      __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get('https://fews.dbnfews.com/storage/rain_assets/' + newTime + '.json').then(function (response) {
        var builder = response.data;
        var header = builder.header;
        var λ0 = header.lo1;
        var φ0 = header.la2; // the grid's origin (e.g., 0.0E, 90.0N)
        var Δλ = header.dx;
        var Δφ = header.dy; // distance between grid points (e.g., 2.5 deg lon, 2.5 deg lat)
        var ni = header.nx;
        var nj = header.ny; // number of grid points W-E and N-S (e.g., 144 x 73)
        var date = new Date(header.refTime);
        date.setHours(date.getHours() + header.forecastTime);

        // Scan mode 0 assumed. Longitude increases from λ0, and latitude decreases from φ0.
        // http://www.nco.ncep.noaa.gov/pmb/docs/grib2/grib2_table3-4.shtml
        var p = 0;
        var points = [];
        for (var j = 0; j < nj; j++) {
          var currentLat = φ0 + Δφ * j;
          for (var i = 0; i < ni; i++, p++) {
            if (builder.data[p]) {
              var currentLong = λ0 + Δλ * i;
              var point = [currentLat, currentLong, builder.data[p]];
              points.push(point);
            }
          }
        }
        _this.rainfall.data = points;
        _this.rainfall.loading = false;
      });

      __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get('https://fews.dbnfews.com/storage/wind_assets/' + newTime + '.json').then(function (response) {
        _this.wind.data = response.data;
        _this.wind.loading = false;
      });

      __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get('https://fews.dbnfews.com/storage/wave_assets/' + newTime + '.json').then(function (response) {
        _this.wave.data = response.data;
        _this.wave.loading = false;
      });
    },
    'timeline.continuous': function timelineContinuous(live) {
      if (live === true) {
        this.tickTimeInterval();
      }
    }
  },
  methods: {
    zoomUpdate: function zoomUpdate(zoom) {
      this.currentZoom = zoom;
      this.zoom = zoom;
    },
    centerUpdate: function centerUpdate(center) {
      this.center = center;
    },
    setView: function setView(view) {
      this.ui.currentView = view;
    },
    clickCamera: function clickCamera(cam) {
      this.selectedCamera = cam;
    },
    tickTimeInterval: function tickTimeInterval() {
      var _this2 = this;

      Object(__WEBPACK_IMPORTED_MODULE_9_timers__["setTimeout"])(function () {
        if (_this2.timeline.continuous === true) {
          console.log(_this2.timeline.currentDate);
          _this2.timeline.currentDate = parseInt(_this2.timeline.currentDate) + 10800;
          // Only set another timeout if its under the max date
          if (_this2.timeline.currentDate <= _this2.timeline.endDate) {
            _this2.tickTimeInterval();
          }
        }
      }, 3000);
    },
    toggleTimelineContinuous: function toggleTimelineContinuous() {
      this.timeline.continuous = !this.timeline.continuous;
    },
    buildUrl: function buildUrl(position) {
      this.userpin.lat = position.coords.latitude;
      this.userpin.long = position.coords.longitude;
    },
    geoError: function geoError(error) {
      console.log(error);
    }
  }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_leaflet_src_utils_propsBinder_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_leaflet_src_utils_findRealParent_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_leaflet_src_utils_optionsUtils_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_leaflet__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_leaflet_src_mixins_LayerGroup_js__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);









function simpleidw(canvas, map) {
  if (!(this instanceof simpleidw)) {
    return new simpleidw(canvas, map);
  }

  this._map = map;

  this._canvas = canvas = typeof canvas === 'string' ? document.getElementById(canvas) : canvas;

  this._ctx = canvas.getContext('2d');
  this._width = canvas.width;
  this._height = canvas.height;

  this._max = 30;
  this._data = [];
}

simpleidw.prototype = {

  defaultCellSize: 0.25,

  defaultGradient: {
    0.0: '#000066',
    0.1: 'blue',
    0.2: 'cyan',
    0.3: 'lime',
    0.4: 'yellow',
    0.5: 'orange',
    0.6: 'red',
    0.7: 'Maroon',
    0.8: '#660066',
    0.9: '#990099',
    1.0: '#ff66ff'
  },
  data: function data(_data) {
    this._data = _data;
    return this;
  },

  max: function max(_max) {
    this._max = _max;
    return this;
  },

  add: function add(point) {
    this._data.push(point);
    return this;
  },

  clear: function clear() {
    this._data = [];
    return this;
  },

  cellSize: function cellSize(r, p) {
    //Get block distance on maps
    var a = void 0,
        b = void 0;
    if (!p) {
      a = this._map.latLngToContainerPoint([0, 0]);
      b = this._map.latLngToContainerPoint([0 + r, 0 + r]);
    } else {
      var current = this._map.containerPointToLatLng([p[0], p[1]]);
      a = this._map.latLngToContainerPoint([current.lat - r / 2, current.lng - r / 2]);
      b = this._map.latLngToContainerPoint([current.lat + r / 2, current.lng + r / 2]);
    }
    var cellwidth = Math.abs(a.x - b.x);
    var cellheight = Math.abs(a.y - b.y);
    // create a grayscale blurred cell image that we'll use for drawing points
    var cell = this._cell = document.createElement("canvas"),
        ctx = cell.getContext('2d');
    this._r = r;

    cell.width = cellwidth;
    cell.height = cellheight;

    ctx.beginPath();
    ctx.rect(0, 0, cellwidth, cellheight);
    ctx.fill();
    ctx.closePath();

    return this;
  },

  resize: function resize() {
    this._width = this._canvas.width;
    this._height = this._canvas.height;
  },

  gradient: function gradient(grad) {
    // create a 256x1 gradient that we'll use to turn a grayscale heatmap into a colored one
    var canvas = document.createElement("canvas"),
        ctx = canvas.getContext('2d'),
        gradient = ctx.createLinearGradient(0, 0, 0, 256);

    canvas.width = 1;
    canvas.height = 256;

    for (var i in grad) {
      gradient.addColorStop(+i, grad[i]);
    }

    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, 1, 256);

    this._grad = ctx.getImageData(0, 0, 1, 256).data;

    return this;
  },

  draw: function draw(opacity) {
    if (!this._grad) this.gradient(this.defaultGradient);

    var ctx = this._ctx;
    ctx.clearRect(0, 0, this._width, this._height);
    // draw a grayscale idwmap by putting a cell at each data point
    for (var i = 0, len = this._data.length, p; i < len; i++) {
      p = this._data[i];
      if (i % 200 == 0) {
        this.cellSize(this.defaultCellSize, p);
      }
      ctx.globalAlpha = p[2] / this._max;
      ctx.drawImage(this._cell, p[0] - this._r / 2, p[1] - this._r / 2);
    }

    // colorize the heatmap, using opacity value of each pixel to get the right color from our gradient
    var colored = ctx.getImageData(0, 0, this._width, this._height);
    this._colorize(colored.data, this._grad, opacity);
    ctx.putImageData(colored, 0, 0);

    return this;
  },

  _colorize: function _colorize(pixels, gradient, opacity) {
    for (var i = 0, len = pixels.length, j; i < len; i += 4) {
      j = pixels[i + 3] * 4;

      pixels[i] = gradient[j];
      pixels[i + 1] = gradient[j + 1];
      pixels[i + 2] = gradient[j + 2];
      pixels[i + 3] = opacity * 256;
    }
  }
};
window.simpleidw = simpleidw;

__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.IdwLayer = (__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Layer ? __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Layer : __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Class).extend({
  /*
  options: {
      opacity: 0.5,
      maxZoom: 18,
      cellSize: 1,
      exp: 2,
      max: 100
  },
  */
  initialize: function initialize(latlngs, options) {
    this._latlngs = latlngs;
    __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.setOptions(this, options);
  },

  setLatLngs: function setLatLngs(latlngs) {
    this._latlngs = latlngs;
    return this.redraw();
  },

  addLatLng: function addLatLng(latlng) {
    this._latlngs.push(latlng);
    return this.redraw();
  },

  setOptions: function setOptions(options) {
    __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.setOptions(this, options);
    if (this._idw) {
      this._updateOptions();
    }
    return this.redraw();
  },

  redraw: function redraw() {
    if (this._idw && !this._frame && !this._map._animating) {
      this._frame = __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Util.requestAnimFrame(this._redraw, this);
    }
    return this;
  },

  onAdd: function onAdd(map) {
    this._map = map;

    if (!this._canvas) {
      this._initCanvas();
    }

    map._panes.overlayPane.appendChild(this._canvas);

    map.on('moveend', this._reset, this);

    if (map.options.zoomAnimation && __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Browser.any3d) {
      map.on('zoomanim', this._animateZoom, this);
    }

    this._reset();
  },

  onRemove: function onRemove(map) {
    map.getPanes().overlayPane.removeChild(this._canvas);

    map.off('moveend', this._reset, this);

    if (map.options.zoomAnimation) {
      map.off('zoomanim', this._animateZoom, this);
    }
  },

  addTo: function addTo(map) {
    map.addLayer(this);
    return this;
  },

  _initCanvas: function _initCanvas() {
    var canvas = this._canvas = __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.create('canvas', 'leaflet-idwmap-layer leaflet-layer');

    var originProp = __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.testProp(['transformOrigin', 'WebkitTransformOrigin', 'msTransformOrigin']);
    canvas.style[originProp] = '50% 50%';

    var size = this._map.getSize();
    canvas.width = size.x;
    canvas.height = size.y;

    var animated = this._map.options.zoomAnimation && __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Browser.any3d;
    __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.addClass(canvas, 'leaflet-zoom-' + (animated ? 'animated' : 'hide'));
    this._idw = simpleidw(canvas, this._map);
    this._updateOptions();
  },

  _updateOptions: function _updateOptions() {
    this._idw.defaultCellSize = this.options.cellSize || this._idw.defaultCellSize;

    if (this.options.gradient) {
      this._idw.gradient(this.options.gradient);
    }
    if (this.options.max) {
      this._idw.max(this.options.max);
    }
  },

  _reset: function _reset() {
    var topLeft = this._map.containerPointToLayerPoint([0, 0]);
    __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.setPosition(this._canvas, topLeft);

    var size = this._map.getSize();

    if (this._idw._width !== size.x) {
      this._canvas.width = this._idw._width = size.x;
    }
    if (this._idw._height !== size.y) {
      this._canvas.height = this._idw._height = size.y;
    }

    this._redraw();
  },

  _redraw: function _redraw() {
    var _this = this;

    if (!this._map) {
      return;
    }

    var pointData = [];
    __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.forEach(this._latlngs, function (item, index) {
      var item2 = _this._map.latLngToContainerPoint(item);
      pointData.push([item2.x, item2.y, item[2]]);
    });
    this._idw.data(pointData).draw(this.options.opacity);

    this._frame = null;
  },

  _animateZoom: function _animateZoom(e) {
    var scale = this._map.getZoomScale(e.zoom),
        offset = this._map._getCenterOffset(e.center)._multiplyBy(-scale).subtract(this._map._getMapPanePos());

    if (__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.setTransform) {
      __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.setTransform(this._canvas, offset, scale);
    } else {
      this._canvas.style[__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.TRANSFORM] = __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.getTranslateString(offset) + ' scale(' + scale + ')';
    }
  },
  setData: function setData(data) {
    this.setLatLngs(data);
  }
});

__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.idwLayer = function (latlngs, options) {
  return new __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.IdwLayer(latlngs, options);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LIwdLayer',
  mixins: [__WEBPACK_IMPORTED_MODULE_5_vue2_leaflet_src_mixins_LayerGroup_js__["a" /* default */]],
  props: {
    geojson: {
      type: [Object, Array],
      custom: true,
      default: function _default() {
        return {};
      }
    },
    options: {
      type: Object,
      custom: true,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    mergedOptions: function mergedOptions() {
      return Object(__WEBPACK_IMPORTED_MODULE_3_vue2_leaflet_src_utils_optionsUtils_js__["a" /* optionsMerger */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.layerGroupOptions), this);
    }
  },
  mounted: function mounted() {
    this.mapObject = __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.idwLayer(this.geojson, this.options);
    __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomEvent.on(this.mapObject, this.$listeners);
    Object(__WEBPACK_IMPORTED_MODULE_1_vue2_leaflet_src_utils_propsBinder_js__["a" /* default */])(this, this.mapObject, this.$options.props);
    this.parentContainer = Object(__WEBPACK_IMPORTED_MODULE_2_vue2_leaflet_src_utils_findRealParent_js__["a" /* default */])(this.$parent, true);
    this.parentContainer.addLayer(this, !this.visible);
  },
  beforeDestroy: function beforeDestroy() {
    this.parentContainer.mapObject.removeLayer(this.mapObject);
  },

  methods: {
    setGeojson: function setGeojson(newVal) {
      // this.mapObject.clearLayers()
      this.mapObject.setData(newVal);
    },
    getGeoJSONData: function getGeoJSONData() {
      return this.mapObject.toGeoJSON();
    },
    getBounds: function getBounds() {
      return this.mapObject.getBounds();
    },
    setOptions: function setOptions(newVal, oldVal) {
      // this.mapObject.clearLayers()
      __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.setOptions(this.mapObject, this.mergedOptions);
      this.mapObject.setData(this.geojson);
    },
    setOptionsStyle: function setOptionsStyle(newVal, oldVal) {
      this.mapObject.setStyle(newVal);
    }
  },
  render: function render() {
    return null;
  }
});

/***/ }),
/* 309 */,
/* 310 */,
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_leaflet_src_utils_propsBinder_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_leaflet_src_utils_findRealParent_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_leaflet_src_utils_optionsUtils_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_leaflet__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_leaflet_src_mixins_LayerGroup_js__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__waves_js__ = __webpack_require__(485);







// import _ from 'lodash'


__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.setTransform = __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.setTransform || function (el, offset, scale) {
  var pos = offset || new __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Point(0, 0);

  el.style[__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.TRANSFORM] = (__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Browser.ie3d ? 'translate(' + pos.x + 'px,' + pos.y + 'px)' : 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') + (scale ? ' scale(' + scale + ')' : '');
};

// -- support for both  0.0.7 and 1.0.0 rc2 leaflet
__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.CanvasLayer = (__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Layer ? __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Layer : __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Class).extend({
  // -- initialized is called on prototype
  initialize: function initialize(options) {
    this._map = null;
    this._canvas = null;
    this._frame = null;
    this._delegate = null;
    __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.setOptions(this, options);
  },

  delegate: function delegate(del) {
    this._delegate = del;
    return this;
  },

  needRedraw: function needRedraw() {
    if (!this._frame) {
      this._frame = __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Util.requestAnimFrame(this.drawLayer, this);
    }
    return this;
  },

  // -------------------------------------------------------------
  _onLayerDidResize: function _onLayerDidResize(resizeEvent) {
    this._canvas.width = resizeEvent.newSize.x;
    this._canvas.height = resizeEvent.newSize.y;
  },
  // -------------------------------------------------------------
  _onLayerDidMove: function _onLayerDidMove() {
    var topLeft = this._map.containerPointToLayerPoint([0, 0]);
    __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.setPosition(this._canvas, topLeft);
    this.drawLayer();
  },
  // -------------------------------------------------------------
  getEvents: function getEvents() {
    var events = {
      resize: this._onLayerDidResize,
      moveend: this._onLayerDidMove
    };
    if (this._map.options.zoomAnimation && __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Browser.any3d) {
      events.zoomanim = this._animateZoom;
    }

    return events;
  },
  // -------------------------------------------------------------
  onAdd: function onAdd(map) {
    this._map = map;
    this._canvas = __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.create('canvas', 'leaflet-layer');
    this.tiles = {};
    __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.setTransform(this._canvas, {
      x: -this._map._mapPane._leaflet_pos.x,
      y: -this._map._mapPane._leaflet_pos.y
    });
    var size = this._map.getSize();
    this._canvas.width = size.x;
    this._canvas.height = size.y;

    var animated = this._map.options.zoomAnimation && __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Browser.any3d;
    __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.addClass(this._canvas, 'leaflet-zoom-' + (animated ? 'animated' : 'hide'));

    map._panes.overlayPane.appendChild(this._canvas);

    map.on(this.getEvents(), this);

    var del = this._delegate || this;
    del.onLayerDidMount && del.onLayerDidMount(); // -- callback
    this.needRedraw();
  },

  // -------------------------------------------------------------
  onRemove: function onRemove(map) {
    var del = this._delegate || this;
    del.onLayerWillUnmount && del.onLayerWillUnmount(); // -- callback

    map.getPanes().overlayPane.removeChild(this._canvas);

    map.off(this.getEvents(), this);

    this._canvas = null;
  },

  // ------------------------------------------------------------
  addTo: function addTo(map) {
    map.addLayer(this);
    return this;
  },
  // --------------------------------------------------------------------------------
  LatLonToMercator: function LatLonToMercator(latlon) {
    return {
      x: latlon.lng * 6378137 * Math.PI / 180,
      y: Math.log(Math.tan((90 + latlon.lat) * Math.PI / 360)) * 6378137
    };
  },

  // ------------------------------------------------------------------------------
  drawLayer: function drawLayer() {
    // -- todo make the viewInfo properties  flat objects.
    var size = this._map.getSize();
    var bounds = this._map.getBounds();
    var zoom = this._map.getZoom();

    var center = this.LatLonToMercator(this._map.getCenter());
    var corner = this.LatLonToMercator(this._map.containerPointToLatLng(this._map.getSize()));

    var del = this._delegate || this;
    del.onDrawLayer && del.onDrawLayer({
      layer: this,
      canvas: this._canvas,
      bounds: bounds,
      size: size,
      zoom: zoom,
      center: center,
      corner: corner
    });
    this._frame = null;
  },
  // -- L.DomUtil.setTransform from leaflet 1.0.0 to work on 0.0.7
  // ------------------------------------------------------------------------------
  _setTransform: function _setTransform(el, offset, scale) {
    var pos = offset || new __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Point(0, 0);

    el.style[__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.TRANSFORM] = (__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Browser.ie3d ? 'translate(' + pos.x + 'px,' + pos.y + 'px)' : 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') + (scale ? ' scale(' + scale + ')' : '');
  },

  // ------------------------------------------------------------------------------
  _animateZoom: function _animateZoom(e) {
    var scale = this._map.getZoomScale(e.zoom);
    // -- different calc of offset in leaflet 1.0.0 and 0.0.7 thanks for 1.0.0-rc2 calc @jduggan1
    var offset = __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Layer ? this._map._latLngToNewLayerPoint(this._map.getBounds().getNorthWest(), e.zoom, e.center) : this._map._getCenterOffset(e.center)._multiplyBy(-scale).subtract(this._map._getMapPanePos());

    __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.setTransform(this._canvas, offset, scale);
  }
});

__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.canvasLayer = function () {
  return new __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.CanvasLayer();
};

__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Map.mergeOptions({
  positionControl: false
});

__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.WaveLayer = (__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Layer ? __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Layer : __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Class).extend({
  options: {
    displayValues: false,
    maxVelocity: 30, // used to align color scale
    colorScale: null,
    data: null
  },

  _map: null,
  _canvasLayer: null,
  _windy: null,
  _context: null,
  _timer: 0,
  _mouseControl: null,

  initialize: function initialize(options) {
    __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.setOptions(this, options);
  },

  onAdd: function onAdd(map) {
    // create canvas, add overlay control
    this._canvasLayer = __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.canvasLayer().delegate(this);
    this._canvasLayer.addTo(map);
    this._map = map;
  },

  onRemove: function onRemove(map) {
    this._destroyWind();
  },

  setData: function setData(data) {
    this.options.data = data;
    if (this._windy) {
      this._windy.setData(data);
      this._clearAndRestart();
    }

    this.fire('load');
  },

  /* ------------------------------------ PRIVATE ------------------------------------------ */

  onDrawLayer: function onDrawLayer(overlay, params) {
    var self = this;

    if (!this._windy) {
      this._initWindy(this);
      return;
    }

    if (!this.options.data) {
      return;
    }

    if (this._timer) clearTimeout(self._timer);

    this._timer = setTimeout(function () {
      self._startWindy();
    }, 750); // showing velocity is delayed
  },

  _startWindy: function _startWindy() {
    var bounds = this._map.getBounds();
    var size = this._map.getSize();
    // bounds, width, height, extent
    this._windy.start([[0, 0], [size.x, size.y]], size.x, size.y, [[bounds._southWest.lng, bounds._southWest.lat], [bounds._northEast.lng, bounds._northEast.lat]]);
  },

  _initWindy: function _initWindy(self) {
    // windy object
    this._windy = new __WEBPACK_IMPORTED_MODULE_6__waves_js__["a" /* default */]({
      canvas: self._canvasLayer._canvas,
      data: self.options.data,
      velocityScale: self.options.velocityScale || 0.005,
      minVelocity: self.options.minVelocity || 0,
      maxVelocity: self.options.maxVelocity || 10,
      particleWidth: self.options.particleWidth || 1,
      colorScale: self.options.colorScale || null
    });

    // prepare context global let, start drawing
    this._context = this._canvasLayer._canvas.getContext('2d');
    this._canvasLayer._canvas.classList.add('velocity-overlay');
    this.onDrawLayer();

    this._map.on('dragstart', self._windy.stop);
    this._map.on('dragend', self._clearAndRestart);
    this._map.on('zoomstart', self._windy.stop);
    this._map.on('zoomend', self._clearAndRestart);
    this._map.on('resize', self._clearWind);
  },

  _clearAndRestart: function _clearAndRestart() {
    console.log('restart');
    if (this._context) this._context.clearRect(0, 0, 3000, 3000);
    if (this._windy) this._startWindy();
  },

  _clearWind: function _clearWind() {
    if (this._windy) this._windy.stop();
    if (this._context) this._context.clearRect(0, 0, 3000, 3000);
  },

  _destroyWind: function _destroyWind() {
    if (this._timer) clearTimeout(this._timer);
    if (this._windy) this._windy.stop();
    if (this._context) this._context.clearRect(0, 0, 3000, 3000);
    this._windy = null;
    this._map.removeLayer(this._canvasLayer);
  }
});

__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.waveLayer = function (options) {
  return new __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.WaveLayer(options);
};

if (!window.cancelAnimationFrame) {
  window.cancelAnimationFrame = function (id) {
    clearTimeout(id);
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LWaveLeaflet',
  mixins: [__WEBPACK_IMPORTED_MODULE_5_vue2_leaflet_src_mixins_LayerGroup_js__["a" /* default */]],
  props: {
    geojson: {
      type: [Object, Array],
      custom: true,
      default: function _default() {
        return {};
      }
    },
    options: {
      type: Object,
      custom: true,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    mergedOptions: function mergedOptions() {
      return Object(__WEBPACK_IMPORTED_MODULE_3_vue2_leaflet_src_utils_optionsUtils_js__["a" /* optionsMerger */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.layerGroupOptions), this);
    }
  },
  mounted: function mounted() {
    this.mapObject = __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.waveLayer(this.options);
    this.mapObject.setData(this.geojson);
    __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomEvent.on(this.mapObject, this.$listeners);
    Object(__WEBPACK_IMPORTED_MODULE_1_vue2_leaflet_src_utils_propsBinder_js__["a" /* default */])(this, this.mapObject, this.$options.props);
    this.parentContainer = Object(__WEBPACK_IMPORTED_MODULE_2_vue2_leaflet_src_utils_findRealParent_js__["a" /* default */])(this.$parent, true);
    this.parentContainer.addLayer(this, !this.visible);
  },
  beforeDestroy: function beforeDestroy() {
    this.parentContainer.mapObject.removeLayer(this.mapObject);
  },

  methods: {
    setGeojson: function setGeojson(newVal) {
      // this.mapObject.clearLayers()
      this.mapObject.setData(newVal);
    },
    getBounds: function getBounds() {
      return this.mapObject.getBounds();
    },
    setOptions: function setOptions(newVal, oldVal) {
      // this.mapObject.clearLayers()
      __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.setOptions(this.mapObject, this.mergedOptions);
      this.mapObject.setData(this.geojson);
    },
    setOptionsStyle: function setOptionsStyle(newVal, oldVal) {
      this.mapObject.setStyle(newVal);
    }
  },
  render: function render() {
    return null;
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_leaflet_src_utils_propsBinder_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_leaflet_src_utils_findRealParent_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_leaflet_src_utils_optionsUtils_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_leaflet__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_leaflet_src_mixins_LayerGroup_js__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__windy_js__ = __webpack_require__(487);







// import _ from 'lodash'


__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.setTransform = __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.setTransform || function (el, offset, scale) {
  var pos = offset || new __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Point(0, 0);

  el.style[__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.TRANSFORM] = (__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Browser.ie3d ? 'translate(' + pos.x + 'px,' + pos.y + 'px)' : 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') + (scale ? ' scale(' + scale + ')' : '');
};

// -- support for both  0.0.7 and 1.0.0 rc2 leaflet
__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.CanvasLayer = (__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Layer ? __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Layer : __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Class).extend({
  // -- initialized is called on prototype
  initialize: function initialize(options) {
    this._map = null;
    this._canvas = null;
    this._frame = null;
    this._delegate = null;
    __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.setOptions(this, options);
  },

  delegate: function delegate(del) {
    this._delegate = del;
    return this;
  },

  needRedraw: function needRedraw() {
    if (!this._frame) {
      this._frame = __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Util.requestAnimFrame(this.drawLayer, this);
    }
    return this;
  },

  // -------------------------------------------------------------
  _onLayerDidResize: function _onLayerDidResize(resizeEvent) {
    this._canvas.width = resizeEvent.newSize.x;
    this._canvas.height = resizeEvent.newSize.y;
  },
  // -------------------------------------------------------------
  _onLayerDidMove: function _onLayerDidMove() {
    var topLeft = this._map.containerPointToLayerPoint([0, 0]);
    __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.setPosition(this._canvas, topLeft);
    this.drawLayer();
  },
  // -------------------------------------------------------------
  getEvents: function getEvents() {
    var events = {
      resize: this._onLayerDidResize,
      moveend: this._onLayerDidMove
    };
    if (this._map.options.zoomAnimation && __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Browser.any3d) {
      events.zoomanim = this._animateZoom;
    }

    return events;
  },
  // -------------------------------------------------------------
  onAdd: function onAdd(map) {
    this._map = map;
    this._canvas = __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.create('canvas', 'leaflet-layer');
    this.tiles = {};
    __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.setTransform(this._canvas, {
      x: -this._map._mapPane._leaflet_pos.x,
      y: -this._map._mapPane._leaflet_pos.y
    });
    var size = this._map.getSize();
    this._canvas.width = size.x;
    this._canvas.height = size.y;

    var animated = this._map.options.zoomAnimation && __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Browser.any3d;
    __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.addClass(this._canvas, 'leaflet-zoom-' + (animated ? 'animated' : 'hide'));

    map._panes.overlayPane.appendChild(this._canvas);

    map.on(this.getEvents(), this);

    var del = this._delegate || this;
    del.onLayerDidMount && del.onLayerDidMount(); // -- callback
    this.needRedraw();
  },

  // -------------------------------------------------------------
  onRemove: function onRemove(map) {
    var del = this._delegate || this;
    del.onLayerWillUnmount && del.onLayerWillUnmount(); // -- callback

    map.getPanes().overlayPane.removeChild(this._canvas);

    map.off(this.getEvents(), this);

    this._canvas = null;
  },

  // ------------------------------------------------------------
  addTo: function addTo(map) {
    map.addLayer(this);
    return this;
  },
  // --------------------------------------------------------------------------------
  LatLonToMercator: function LatLonToMercator(latlon) {
    return {
      x: latlon.lng * 6378137 * Math.PI / 180,
      y: Math.log(Math.tan((90 + latlon.lat) * Math.PI / 360)) * 6378137
    };
  },

  // ------------------------------------------------------------------------------
  drawLayer: function drawLayer() {
    // -- todo make the viewInfo properties  flat objects.
    var size = this._map.getSize();
    var bounds = this._map.getBounds();
    var zoom = this._map.getZoom();

    var center = this.LatLonToMercator(this._map.getCenter());
    var corner = this.LatLonToMercator(this._map.containerPointToLatLng(this._map.getSize()));

    var del = this._delegate || this;
    del.onDrawLayer && del.onDrawLayer({
      layer: this,
      canvas: this._canvas,
      bounds: bounds,
      size: size,
      zoom: zoom,
      center: center,
      corner: corner
    });
    this._frame = null;
  },
  // -- L.DomUtil.setTransform from leaflet 1.0.0 to work on 0.0.7
  // ------------------------------------------------------------------------------
  _setTransform: function _setTransform(el, offset, scale) {
    var pos = offset || new __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Point(0, 0);

    el.style[__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.TRANSFORM] = (__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Browser.ie3d ? 'translate(' + pos.x + 'px,' + pos.y + 'px)' : 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') + (scale ? ' scale(' + scale + ')' : '');
  },

  // ------------------------------------------------------------------------------
  _animateZoom: function _animateZoom(e) {
    var scale = this._map.getZoomScale(e.zoom);
    // -- different calc of offset in leaflet 1.0.0 and 0.0.7 thanks for 1.0.0-rc2 calc @jduggan1
    var offset = __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Layer ? this._map._latLngToNewLayerPoint(this._map.getBounds().getNorthWest(), e.zoom, e.center) : this._map._getCenterOffset(e.center)._multiplyBy(-scale).subtract(this._map._getMapPanePos());

    __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomUtil.setTransform(this._canvas, offset, scale);
  }
});

__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.canvasLayer = function () {
  return new __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.CanvasLayer();
};

__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Map.mergeOptions({
  positionControl: false
});

__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.VelocityLayer = (__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Layer ? __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Layer : __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Class).extend({
  options: {
    displayValues: false,
    maxVelocity: 30, // used to align color scale
    colorScale: null,
    data: null
  },

  _map: null,
  _canvasLayer: null,
  _windy: null,
  _context: null,
  _timer: 0,
  _mouseControl: null,

  initialize: function initialize(options) {
    __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.setOptions(this, options);
  },

  onAdd: function onAdd(map) {
    // create canvas, add overlay control
    this._canvasLayer = __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.canvasLayer().delegate(this);
    this._canvasLayer.addTo(map);
    this._map = map;
  },

  onRemove: function onRemove(map) {
    this._destroyWind();
  },

  setData: function setData(data) {
    this.options.data = data;

    if (this._windy) {
      this._windy.setData(data);
      this._clearAndRestart();
    }

    this.fire('load');
  },

  /* ------------------------------------ PRIVATE ------------------------------------------ */

  onDrawLayer: function onDrawLayer(overlay, params) {
    var self = this;

    if (!this._windy) {
      this._initWindy(this);
      return;
    }
    if (!this.options.data) {
      return;
    }

    if (this._timer) clearTimeout(self._timer);

    this._timer = setTimeout(function () {
      self._startWindy();
    }, 750); // showing velocity is delayed
  },

  _startWindy: function _startWindy() {
    var bounds = this._map.getBounds();
    var size = this._map.getSize();
    // bounds, width, height, extent
    this._windy.start([[0, 0], [size.x, size.y]], size.x, size.y, [[bounds._southWest.lng, bounds._southWest.lat], [bounds._northEast.lng, bounds._northEast.lat]]);
  },

  _initWindy: function _initWindy(self) {
    // windy object
    this._windy = new __WEBPACK_IMPORTED_MODULE_6__windy_js__["a" /* default */]({
      canvas: self._canvasLayer._canvas,
      data: self.options.data,
      velocityScale: self.options.velocityScale || 0.005,
      minVelocity: self.options.minVelocity || 0,
      maxVelocity: self.options.maxVelocity || 10,
      particleWidth: self.options.particleWidth || 1,
      colorScale: self.options.colorScale || null
    });

    // prepare context global let, start drawing
    this._context = this._canvasLayer._canvas.getContext('2d');
    this._canvasLayer._canvas.classList.add('velocity-overlay');
    this.onDrawLayer();

    this._map.on('dragstart', self._windy.stop);
    this._map.on('dragend', self._clearAndRestart);
    this._map.on('zoomstart', self._windy.stop);
    this._map.on('zoomend', self._clearAndRestart);
    this._map.on('resize', self._clearWind);
  },

  _clearAndRestart: function _clearAndRestart() {
    if (this._context) this._context.clearRect(0, 0, 3000, 3000);
    if (this._windy) this._startWindy();
  },

  _clearWind: function _clearWind() {
    if (this._windy) this._windy.stop();
    if (this._context) this._context.clearRect(0, 0, 3000, 3000);
  },

  _destroyWind: function _destroyWind() {
    if (this._timer) clearTimeout(this._timer);
    if (this._windy) this._windy.stop();
    if (this._context) this._context.clearRect(0, 0, 3000, 3000);
    this._windy = null;
    this._map.removeLayer(this._canvasLayer);
  }
});

__WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.velocityLayer = function (options) {
  return new __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.VelocityLayer(options);
};

if (!window.cancelAnimationFrame) {
  window.cancelAnimationFrame = function (id) {
    clearTimeout(id);
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LVectorLeaflet',
  mixins: [__WEBPACK_IMPORTED_MODULE_5_vue2_leaflet_src_mixins_LayerGroup_js__["a" /* default */]],
  props: {
    geojson: {
      type: [Object, Array],
      custom: true,
      default: function _default() {
        return {};
      }
    },
    options: {
      type: Object,
      custom: true,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    mergedOptions: function mergedOptions() {
      return Object(__WEBPACK_IMPORTED_MODULE_3_vue2_leaflet_src_utils_optionsUtils_js__["a" /* optionsMerger */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.layerGroupOptions), this);
    }
  },
  mounted: function mounted() {
    this.mapObject = __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.velocityLayer(this.options);
    this.mapObject.setData(this.geojson);
    __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.DomEvent.on(this.mapObject, this.$listeners);
    Object(__WEBPACK_IMPORTED_MODULE_1_vue2_leaflet_src_utils_propsBinder_js__["a" /* default */])(this, this.mapObject, this.$options.props);
    this.parentContainer = Object(__WEBPACK_IMPORTED_MODULE_2_vue2_leaflet_src_utils_findRealParent_js__["a" /* default */])(this.$parent, true);
    this.parentContainer.addLayer(this, !this.visible);
  },
  beforeDestroy: function beforeDestroy() {
    this.parentContainer.mapObject.removeLayer(this.mapObject);
  },

  methods: {
    setGeojson: function setGeojson(newVal) {
      // this.mapObject.clearLayers()
      this.mapObject.setData(newVal);
    },
    getBounds: function getBounds() {
      return this.mapObject.getBounds();
    },
    setOptions: function setOptions(newVal, oldVal) {
      // this.mapObject.clearLayers()
      __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.setOptions(this.mapObject, this.mergedOptions);
      this.mapObject.setData(this.geojson);
    },
    setOptionsStyle: function setOptionsStyle(newVal, oldVal) {
      this.mapObject.setStyle(newVal);
    }
  },
  render: function render() {
    return null;
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(15);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'camsview',
  props: ['selectedCam', 'changeCam'],
  mounted: function mounted() {
    var _this = this;

    this.getCameras().then(function () {
      _this.loading = false;
    });
  },
  data: function data() {
    return {
      loading: true
    };
  },
  computed: {
    cams: function cams() {
      return this.$store.getters.cameras;
    },
    storageUrl: function storageUrl() {
      return this.$store.getters.storageEndpoint;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['getCameras']), {
    clearCam: function clearCam() {
      this.changeCam({});
    }
  })
});

/***/ }),
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALiSURBVGhD7Zm/axNhGMcz+R8IFXJ3QwVRu3Wwg2BV2kH8hY666CQ4iU4uKpjc5UfTYEOLtjGdROpS2wp2KNFaTJUMghXEKq3eXUrSDkWtTaH4+j7pGzyTJ9dc0nsvkfvCB67v+/z4fnOBDPW4cuWqfnkD+llR0cdERUtzRdafCrJ+htmoTzRAhEKchIYJMTu1SQqoR7HBTiDJaiezZV2Cot3HhjrEALNlXfSVTiADHYF6GWe2rKvBgkwwW9blBqG0BlVyOZ4ikZFx0kO5NJQqnGG11eBIkNP978jCdISQ9O1/gLOT9A7r2Q7uQY7H5sj3WV9ZiCJwd6zvA9prBvcgyck4GsDI1PM42msG1yBt4QWymb6DmjcCNQfDi+iMSnAN0hV7jxrHgFpsRiW4BumIfkJNY0AtNqMSXIMAX6Z7UeNGPr+Mor1mcA9ydfgVat7IlYczaK8Z3IMAgcfPyG8kAJwp9A7r2Q5HggDwozgy9oh8fHGvADyfqvHHEHAsyE7jeBApsAV2ZwXuQToGcuTik1Vyc2qN+GfypPfNRgF4hrML9O5Qfw7tNYNbkPZYltyY/Emibzeq4jqtbe/LorMwuATpTqyQ8GweNWxGKJUnXbQXm1mK7UE6h5ZJBDFZLdB7ZHAZnW3E1iD7epaI8nodNWgFmAGzsB1FbA3SPbyCGqsFmIXtKGJvEPr9xkzVAszCdhSxNcj+SIYcfpDbEWAWtqOIrUF44gYB/TdBREUbxYY6gzbKbFkX/RRC+FD+CLIWYLasy+v/tpeGyWODuSLrv4Tg11ZmqzaJcuY8fa1r6AIuaD8kJXOO2alP4t3FPYKsXhMUPQb/M6kEXZwQZW2z3EwJWzUJbMZf6C66UwpmW5gNvoLlZcZLgBpW3tiin+ggFgCAO1bW+Dpwa24X/Woky0PoSbhjZc2hFl9mNzU/bwgyD2fsurnk9S210bewCsAzO25OSX71BMD+dOXKlSPyeP4AgkB/DM9p+ecAAAAASUVORK5CYII="

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profile_Profile__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(15);

//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profile',
  components: {
    ProfileCard: __WEBPACK_IMPORTED_MODULE_1__components_profile_Profile__["a" /* default */]
  },
  data: function data() {
    return {};
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapState */])({
    user: function user(state) {
      return state.user;
    },
    weatherRegions: function weatherRegions(state) {
      return state.weatherRegions;
    }
  })),
  mounted: function mounted() {
    // this.$store.dispatch('getUserInfo')
    // this.$store.dispatch('getWeatherRegions')
  }
});

/***/ }),
/* 323 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_alertifyjs_build_alertify_min_js__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_alertifyjs_build_alertify_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_alertifyjs_build_alertify_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_alertifyjs_build_css_alertify_min_css__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_alertifyjs_build_css_alertify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_alertifyjs_build_css_alertify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_alertifyjs_build_css_themes_default_min_css__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_alertifyjs_build_css_themes_default_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_alertifyjs_build_css_themes_default_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_polyfill__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__babel_polyfill__);




var _this = this;

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










window.alertify = __WEBPACK_IMPORTED_MODULE_8_alertifyjs_build_alertify_min_js___default.a;

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_8_alertifyjs_build_alertify_min_js___default.a.set('notifier', 'delay', 5);
__WEBPACK_IMPORTED_MODULE_8_alertifyjs_build_alertify_min_js___default.a.set('notifier', 'position', 'top-center');
__WEBPACK_IMPORTED_MODULE_8_alertifyjs_build_alertify_min_js___default.a.set('prompt', 'reverseButtons', true);
__WEBPACK_IMPORTED_MODULE_8_alertifyjs_build_alertify_min_js___default.a.set('prompt', 'transition', 'fade');
__WEBPACK_IMPORTED_MODULE_8_alertifyjs_build_alertify_min_js___default.a.set('confirm', 'transition', 'fade');

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$axios = __WEBPACK_IMPORTED_MODULE_7_axios___default.a.create({
  headers: {
    'Content-Type': 'application/json',
    'Authorization': __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.jwt
  },
  baseURL: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.apiEndpoint
});

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$axios.interceptors.request.use(function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(config) {
    var token, found;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            token = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.jwt;

            if (token) {
              config.headers['Authorization'] = token;
            }
            if (!__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters.isUserLoggedOut) {
              if (__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters.isTokenExpired) {
                found = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.notAuthUrls.find(function (element) {
                  return element === config.url;
                });

                if (!found) {
                  __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('refreshToken').then(function (response) {
                    return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].nextTick(function () {
                      config.headers.Authorization = response.headers.authorization;
                      return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$axios(config);
                    });
                  });
                }
              }
            }
            return _context.abrupt('return', config);

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}(), function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error && error.response && error.response.status && error.response.status === 401) {
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('removeJWT');

    // Avoid showing any errors
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
  } else {
    console.log(error);
    // logger.error({
    //   message: 'Error in HTTP request',
    //   response: JSON.stringify(extractError(error)),
    //   status: _get(error, 'response.status', 'unknown'),
    //   url: _get(error, 'config.url', 'unknown'),
    //   userId: store.getters.userInfo.id
    // })
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */] }
});

// var elem = document.querySelector('.grid')
// new Masonry(elem, {
//   itemSelector: '.grid .card',
//   columnWidth: 200,
//   horizontalOrder: true
// })

/***/ }),
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(150);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed06c8b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(393);
function injectStyle (ssrContext) {
  __webpack_require__(385)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed06c8b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */,
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RainAlertModal_vue__ = __webpack_require__(151);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b7b86ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RainAlertModal_vue__ = __webpack_require__(388);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RainAlertModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b7b86ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RainAlertModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"modalAlertTips"}},[_c('a',{on:{"click":_vm.closeModal}},[_c('span',[_vm._v("×")])]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('img',{attrs:{"src":"static/img/alertcard-modal/Artboard 1.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"static/img/alertcard-modal/Artboard 2.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"static/img/alertcard-modal/Artboard 3.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"static/img/alertcard-modal/Artboard 4.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"static/img/alertcard-modal/Artboard 5.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"static/img/alertcard-modal/Artboard 6.png","alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WavesAlertModal_vue__ = __webpack_require__(152);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19b95b26_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WavesAlertModal_vue__ = __webpack_require__(390);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WavesAlertModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19b95b26_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WavesAlertModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"modalAlertTips"}},[_c('a',{on:{"click":_vm.closeModal}},[_c('span',[_vm._v("×")])]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('img',{attrs:{"src":"static/img/alertcard-modal/Artboard 1.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"static/img/alertcard-modal/Artboard 2.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"static/img/alertcard-modal/Artboard 3.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"static/img/alertcard-modal/Artboard 4.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"static/img/alertcard-modal/Artboard 5.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"static/img/alertcard-modal/Artboard 6.png","alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WindAlertModal_vue__ = __webpack_require__(153);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cf8fdc6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WindAlertModal_vue__ = __webpack_require__(392);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WindAlertModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cf8fdc6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WindAlertModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"modalAlertTips"}},[_c('a',{on:{"click":_vm.closeModal}},[_c('span',[_vm._v("×")])]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('img',{attrs:{"src":"static/img/alertcard-modal/Artboard 1.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"static/img/alertcard-modal/Artboard 2.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"static/img/alertcard-modal/Artboard 3.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"static/img/alertcard-modal/Artboard 4.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"static/img/alertcard-modal/Artboard 5.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"static/img/alertcard-modal/Artboard 6.png","alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.bodyClasses,attrs:{"id":"app"}},[_c('header',[_c('router-link',{staticClass:"btn logo",attrs:{"to":"/"}},[_c('img',{attrs:{"src":"/static/img/cl_ethek_logo_new.svg"}})]),_vm._v(" "),_c('router-link',{staticClass:"btn viewMap",attrs:{"to":"/map"}},[_c('i',{staticClass:"icon-location"}),_vm._v("View Interactive Map")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"btn",attrs:{"to":"/report"}},[_c('i',{staticClass:"icon-report"})]),_vm._v(" "),(_vm.user)?_c('router-link',{staticClass:"btn",attrs:{"to":"/profile"}},[_c('i',{staticClass:"icon-user"})]):_vm._e(),_vm._v(" "),(!_vm.user)?_c('router-link',{staticClass:"btn",attrs:{"to":"/login"}},[_c('i',{staticClass:"icon-user"})]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"main"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_vm._v(" "),(this.showModal == 'rainModal')?_c('RainAlertModal'):_vm._e(),_vm._v(" "),(this.showModal == 'wavesModal')?_c('WavesAlertModal'):_vm._e(),_vm._v(" "),(this.showModal == 'windModal')?_c('WindAlertModal'):_vm._e()],1),_vm._v(" "),_vm._m(1),_vm._v(" "),(_vm.isAddedHome == false)?_c('div',{attrs:{"id":"addHomScreen"}},[_c('button',{staticClass:"closeBtn btn btn-faded",on:{"click":_vm.homeScreen}},[_vm._v("x")]),_vm._v(" "),_c('img',{staticClass:"appIcon",attrs:{"src":"/static/img/icons/android-chrome-192x192.png","alt":""}}),_vm._v("\n    Install this to your homescreen."),_c('br'),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn viewMap",attrs:{"href":"https://data.ethekwinifews.durban/","target":"_blank"}},[_c('i',{staticClass:"icon-search"}),_vm._v("Get Datafeeds")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"responseGate"},[_c('img',{attrs:{"src":"/static/img/logo.svg"}}),_vm._v(" "),_c('p',[_vm._v("This web app is best experienced in portrait mode. "),_c('br'),_vm._v("Please rotate your device.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iosInfo"},[_vm._v("\n      Tap "),_c('img',{staticClass:"shareIcon",attrs:{"src":"/static/img/install/icon-ios-share.png","alt":""}}),_vm._v(" "),_c('b',[_vm._v("Share")]),_vm._v(",\n      "),_c('br'),_vm._v("then "),_c('img',{staticClass:"homescreenIcon",attrs:{"src":"/static/img/install/icon-ios-add-to-homescreen.png","alt":""}}),_c('b',[_vm._v("Add to Home Screen")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"androidInfo"},[_vm._v("\n      Tap "),_c('img',{staticClass:"shareIcon",attrs:{"src":"/static/img/install/icon-android-menu.png","alt":""}}),_vm._v(" "),_c('b',[_vm._v("Menu")]),_vm._v(",\n      "),_c('br'),_vm._v("then "),_c('b',[_vm._v("Add to Home Screen")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Login__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_login_Register__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_login_Login__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_login_ResetPassword__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_login_EmailLogin__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_login_GoogleLogin__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_login_FacebookLogin__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Report__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Map__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Profile__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Link__ = __webpack_require__(513);















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Home__["a" /* default */]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Login__["a" /* default */],
    children: [{
      name: 'login-main',
      path: '/',
      component: __WEBPACK_IMPORTED_MODULE_5__components_login_Login__["a" /* default */]
    }, {
      name: 'login-register',
      path: 'register',
      component: __WEBPACK_IMPORTED_MODULE_4__components_login_Register__["a" /* default */]
    }, {
      name: 'login-reset',
      path: 'reset',
      component: __WEBPACK_IMPORTED_MODULE_6__components_login_ResetPassword__["a" /* default */]
    }, {
      name: 'login-reset-token',
      path: 'reset/:token',
      component: __WEBPACK_IMPORTED_MODULE_6__components_login_ResetPassword__["a" /* default */],
      props: true
    }, {
      name: 'login-email',
      path: 'email',
      component: __WEBPACK_IMPORTED_MODULE_7__components_login_EmailLogin__["a" /* default */]
    }, {
      name: 'login-google',
      path: 'google',
      component: __WEBPACK_IMPORTED_MODULE_8__components_login_GoogleLogin__["a" /* default */]
    }, {
      name: 'login-facebook',
      path: 'facebook',
      component: __WEBPACK_IMPORTED_MODULE_9__components_login_FacebookLogin__["a" /* default */]
    }]
  }, {
    path: '/report',
    name: 'Report',
    component: __WEBPACK_IMPORTED_MODULE_10__views_Report__["a" /* default */]
  }, {
    path: '/map',
    name: 'Map',
    component: __WEBPACK_IMPORTED_MODULE_11__views_Map__["a" /* default */]
  }, {
    path: '/map/:section',
    name: 'MapSub',
    component: __WEBPACK_IMPORTED_MODULE_11__views_Map__["a" /* default */]
  }, {
    path: '/profile',
    name: 'Profile',
    component: __WEBPACK_IMPORTED_MODULE_12__views_Profile__["a" /* default */]
  }, {
    path: '/link',
    name: 'Link',
    component: __WEBPACK_IMPORTED_MODULE_13__views_Link__["default"]
  }]
}));

/***/ }),
/* 395 */,
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(154);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee215cae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(439);
function injectStyle (ssrContext) {
  __webpack_require__(397)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee215cae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeCardList_vue__ = __webpack_require__(155);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_626a6e8a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeCardList_vue__ = __webpack_require__(429);
function injectStyle (ssrContext) {
  __webpack_require__(399)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeCardList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_626a6e8a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeCardList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeCardListItem_vue__ = __webpack_require__(156);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24f4376a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeCardListItem_vue__ = __webpack_require__(418);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeCardListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24f4376a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeCardListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Article_vue__ = __webpack_require__(157);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_921f78d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Article_vue__ = __webpack_require__(409);
function injectStyle (ssrContext) {
  __webpack_require__(407)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-921f78d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Article_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_921f78d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Article_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 159,
	"./af.js": 159,
	"./ar": 160,
	"./ar-dz": 161,
	"./ar-dz.js": 161,
	"./ar-kw": 162,
	"./ar-kw.js": 162,
	"./ar-ly": 163,
	"./ar-ly.js": 163,
	"./ar-ma": 164,
	"./ar-ma.js": 164,
	"./ar-sa": 165,
	"./ar-sa.js": 165,
	"./ar-tn": 166,
	"./ar-tn.js": 166,
	"./ar.js": 160,
	"./az": 167,
	"./az.js": 167,
	"./be": 168,
	"./be.js": 168,
	"./bg": 169,
	"./bg.js": 169,
	"./bm": 170,
	"./bm.js": 170,
	"./bn": 171,
	"./bn.js": 171,
	"./bo": 172,
	"./bo.js": 172,
	"./br": 173,
	"./br.js": 173,
	"./bs": 174,
	"./bs.js": 174,
	"./ca": 175,
	"./ca.js": 175,
	"./cs": 176,
	"./cs.js": 176,
	"./cv": 177,
	"./cv.js": 177,
	"./cy": 178,
	"./cy.js": 178,
	"./da": 179,
	"./da.js": 179,
	"./de": 180,
	"./de-at": 181,
	"./de-at.js": 181,
	"./de-ch": 182,
	"./de-ch.js": 182,
	"./de.js": 180,
	"./dv": 183,
	"./dv.js": 183,
	"./el": 184,
	"./el.js": 184,
	"./en-SG": 185,
	"./en-SG.js": 185,
	"./en-au": 186,
	"./en-au.js": 186,
	"./en-ca": 187,
	"./en-ca.js": 187,
	"./en-gb": 188,
	"./en-gb.js": 188,
	"./en-ie": 189,
	"./en-ie.js": 189,
	"./en-il": 190,
	"./en-il.js": 190,
	"./en-nz": 191,
	"./en-nz.js": 191,
	"./eo": 192,
	"./eo.js": 192,
	"./es": 193,
	"./es-do": 194,
	"./es-do.js": 194,
	"./es-us": 195,
	"./es-us.js": 195,
	"./es.js": 193,
	"./et": 196,
	"./et.js": 196,
	"./eu": 197,
	"./eu.js": 197,
	"./fa": 198,
	"./fa.js": 198,
	"./fi": 199,
	"./fi.js": 199,
	"./fo": 200,
	"./fo.js": 200,
	"./fr": 201,
	"./fr-ca": 202,
	"./fr-ca.js": 202,
	"./fr-ch": 203,
	"./fr-ch.js": 203,
	"./fr.js": 201,
	"./fy": 204,
	"./fy.js": 204,
	"./ga": 205,
	"./ga.js": 205,
	"./gd": 206,
	"./gd.js": 206,
	"./gl": 207,
	"./gl.js": 207,
	"./gom-latn": 208,
	"./gom-latn.js": 208,
	"./gu": 209,
	"./gu.js": 209,
	"./he": 210,
	"./he.js": 210,
	"./hi": 211,
	"./hi.js": 211,
	"./hr": 212,
	"./hr.js": 212,
	"./hu": 213,
	"./hu.js": 213,
	"./hy-am": 214,
	"./hy-am.js": 214,
	"./id": 215,
	"./id.js": 215,
	"./is": 216,
	"./is.js": 216,
	"./it": 217,
	"./it-ch": 218,
	"./it-ch.js": 218,
	"./it.js": 217,
	"./ja": 219,
	"./ja.js": 219,
	"./jv": 220,
	"./jv.js": 220,
	"./ka": 221,
	"./ka.js": 221,
	"./kk": 222,
	"./kk.js": 222,
	"./km": 223,
	"./km.js": 223,
	"./kn": 224,
	"./kn.js": 224,
	"./ko": 225,
	"./ko.js": 225,
	"./ku": 226,
	"./ku.js": 226,
	"./ky": 227,
	"./ky.js": 227,
	"./lb": 228,
	"./lb.js": 228,
	"./lo": 229,
	"./lo.js": 229,
	"./lt": 230,
	"./lt.js": 230,
	"./lv": 231,
	"./lv.js": 231,
	"./me": 232,
	"./me.js": 232,
	"./mi": 233,
	"./mi.js": 233,
	"./mk": 234,
	"./mk.js": 234,
	"./ml": 235,
	"./ml.js": 235,
	"./mn": 236,
	"./mn.js": 236,
	"./mr": 237,
	"./mr.js": 237,
	"./ms": 238,
	"./ms-my": 239,
	"./ms-my.js": 239,
	"./ms.js": 238,
	"./mt": 240,
	"./mt.js": 240,
	"./my": 241,
	"./my.js": 241,
	"./nb": 242,
	"./nb.js": 242,
	"./ne": 243,
	"./ne.js": 243,
	"./nl": 244,
	"./nl-be": 245,
	"./nl-be.js": 245,
	"./nl.js": 244,
	"./nn": 246,
	"./nn.js": 246,
	"./pa-in": 247,
	"./pa-in.js": 247,
	"./pl": 248,
	"./pl.js": 248,
	"./pt": 249,
	"./pt-br": 250,
	"./pt-br.js": 250,
	"./pt.js": 249,
	"./ro": 251,
	"./ro.js": 251,
	"./ru": 252,
	"./ru.js": 252,
	"./sd": 253,
	"./sd.js": 253,
	"./se": 254,
	"./se.js": 254,
	"./si": 255,
	"./si.js": 255,
	"./sk": 256,
	"./sk.js": 256,
	"./sl": 257,
	"./sl.js": 257,
	"./sq": 258,
	"./sq.js": 258,
	"./sr": 259,
	"./sr-cyrl": 260,
	"./sr-cyrl.js": 260,
	"./sr.js": 259,
	"./ss": 261,
	"./ss.js": 261,
	"./sv": 262,
	"./sv.js": 262,
	"./sw": 263,
	"./sw.js": 263,
	"./ta": 264,
	"./ta.js": 264,
	"./te": 265,
	"./te.js": 265,
	"./tet": 266,
	"./tet.js": 266,
	"./tg": 267,
	"./tg.js": 267,
	"./th": 268,
	"./th.js": 268,
	"./tl-ph": 269,
	"./tl-ph.js": 269,
	"./tlh": 270,
	"./tlh.js": 270,
	"./tr": 271,
	"./tr.js": 271,
	"./tzl": 272,
	"./tzl.js": 272,
	"./tzm": 273,
	"./tzm-latn": 274,
	"./tzm-latn.js": 274,
	"./tzm.js": 273,
	"./ug-cn": 275,
	"./ug-cn.js": 275,
	"./uk": 276,
	"./uk.js": 276,
	"./ur": 277,
	"./ur.js": 277,
	"./uz": 278,
	"./uz-latn": 279,
	"./uz-latn.js": 279,
	"./uz.js": 278,
	"./vi": 280,
	"./vi.js": 280,
	"./x-pseudo": 281,
	"./x-pseudo.js": 281,
	"./yo": 282,
	"./yo.js": 282,
	"./zh-cn": 283,
	"./zh-cn.js": 283,
	"./zh-hk": 284,
	"./zh-hk.js": 284,
	"./zh-tw": 285,
	"./zh-tw.js": 285
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 408;

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"articleCard",attrs:{"id":"articleCard"}},[(_vm.articleImage != null)?_c('span',{staticClass:"imgWrap"},[_c('img',{staticClass:"backgroundBlur",attrs:{"src":_vm.articleImage}}),_c('img',{staticClass:"img-fluid cardImage",attrs:{"src":_vm.articleImage}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cardHeader"},[_c('span',{staticClass:"profile",style:(_vm.bgImage)}),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.cardData.json_object.title)+" "),_c('small',[_vm._v(_vm._s(_vm.whenDate)+" - "+_vm._s(_vm.cardData.json_object.author))])])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.cardData.json_object.description))]),_vm._v(" "),_c('div',{staticClass:"cardActions"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){return _vm.openArticle()}}},[_vm._v("Read more →")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Photo_vue__ = __webpack_require__(286);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5849e708_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Photo_vue__ = __webpack_require__(412);
function injectStyle (ssrContext) {
  __webpack_require__(411)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5849e708"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Photo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5849e708_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Photo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photoCard"},[_c('div',{staticClass:"photo",style:(_vm.bgImage)}),_vm._v(" "),_c('div',{staticClass:"cardHeader"},[_c('span',{staticClass:"profile",staticStyle:{"background-image":"url(/static/img/placeholder.png)"}}),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.cardData.json_object.title)+" "),_c('small',[_vm._v(_vm._s(_vm.whenDate))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tweet_vue__ = __webpack_require__(287);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a493b15_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tweet_vue__ = __webpack_require__(415);
function injectStyle (ssrContext) {
  __webpack_require__(414)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a493b15"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tweet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a493b15_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tweet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tweetCard",class:{ 'noImage': !_vm.cardImage }},[(_vm.cardData.json_object.extended_entities)?_c('span',{staticClass:"imgWrap"},[_c('img',{staticClass:"backgroundBlur",attrs:{"src":_vm.cardData.json_object.extended_entities.media[0].media_url_https}}),_c('img',{staticClass:" cardImage img-fluid",attrs:{"src":_vm.cardData.json_object.extended_entities.media[0].media_url_https}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cardHeader"},[_c('img',{attrs:{"alt":_vm.cardData.json_object.user.description,"src":_vm.bgImage}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('p',[_vm._v(_vm._s(_vm.cardData.json_object.full_text)+"\n          "),_c('small',[_c('a',{attrs:{"rel":"noopener","href":'https://www.twitter.com/'+_vm.cardData.json_object.user.screen_name,"target":"_blank"}},[_vm._v("@"+_vm._s(_vm.cardData.json_object.user.screen_name))]),_vm._v(" - "+_vm._s(_vm.whenDate))])])])]),_vm._v(" "),_c('div',{staticClass:"cardActions"},[_c('a',{staticClass:"btn btn-default btn-block",attrs:{"href":'https://mobile.twitter.com/' + this.cardData.json_object.user.screen_name + '/status/' + this.cardData.json_object.id_str,"target":"_blank"}},[_vm._v("View Tweet →")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Camera_vue__ = __webpack_require__(288);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_245097e5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Camera_vue__ = __webpack_require__(417);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Camera_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_245097e5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Camera_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cameraCard",attrs:{"id":"cameraCard"}},[_c('div',{staticClass:"photo",style:(_vm.bgcssdata)}),_vm._v(" "),_c('div',{staticClass:"cardHeader"},[_c('h3',[_vm._v("Live camera of the day "),_c('small',[_vm._v(_vm._s(_vm.cardData.json_object.cam.name))])])]),_vm._v(" "),_c('div',{staticClass:"cardActions"},[_c('router-link',{staticClass:"btn btn-default btn-block",attrs:{"to":"/map/cams"}},[_vm._v("View More Live Cameras →")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showArticle)?_c('div',{staticClass:"card",class:_vm.cardType},[(_vm.articleCard)?_c('article-card',{attrs:{"cardData":_vm.card}}):_vm._e(),_vm._v(" "),(_vm.photoCard)?_c('photo-card',{attrs:{"cardData":_vm.card}}):_vm._e(),_vm._v(" "),(_vm.tweetCard)?_c('tweet-card',{attrs:{"cardData":_vm.card}}):_vm._e(),_vm._v(" "),(_vm.cameraCard)?_c('camera-card',{attrs:{"cardData":_vm.card}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Custom_vue__ = __webpack_require__(289);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dd43aef_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Custom_vue__ = __webpack_require__(421);
function injectStyle (ssrContext) {
  __webpack_require__(420)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2dd43aef"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Custom_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dd43aef_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Custom_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customCard",attrs:{"id":"customCard"}},[_c('h2',[_vm._v("Title")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/img/placeholder.png"}}),_vm._v(" "),_c('div',{staticClass:"cardActions"},[_c('button',{staticClass:"btn btn-default btn-block"},[_vm._v("Read more →")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interestsCard",attrs:{"id":"interestsCard"}},[_c('h2',[_vm._v("Select your interests")]),_vm._v(" "),_c('div',{staticClass:"select_container-interests"},[_vm._l((_vm.interests),function(interest){return (_vm.interests)?[_c('div',{key:interest.id,staticClass:"select_container-interests-item",class:{ active: _vm.checkInterest(interest)},on:{"click":function($event){return _vm.addToSelectedOrRemoveFromSelected(interest)}}},[_c('div',{staticClass:"select_container-interests-item-icon"},[_c('img',{attrs:{"src":'/static/img/interests/' + _vm.interestId(interest) + '.svg'}})]),_vm._v(" "),_c('div',{staticClass:"select_container-interests-item-text"},[_c('p',[_vm._v(_vm._s(_vm.interestName(interest)))])])])]:_vm._e()})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__ = __webpack_require__(292);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bcd6c8a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__ = __webpack_require__(426);
function injectStyle (ssrContext) {
  __webpack_require__(425)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3bcd6c8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bcd6c8a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alertCard",class:{ 'tipsOpen' : _vm.tipsopen },attrs:{"id":"alertCard"}},[_c('a',{staticClass:"tooltipIcon",class:{ 'tooltipOpen' : _vm.tooltipOpen },on:{"click":_vm.openTooltip}},[_vm._m(0)]),_vm._v(" "),_c('a',{staticClass:"tooltipAlert"},[_vm._v("\n          South African Weather Service (SAWS) is the custodian of national weather warnings for South Africa and provide warnings on a regional scale. eThekwini Municipality, in close collaboration with SAWS, assess the local IMPACTS of the adverse FORECASTED WEATHER events issued by SAWS and provide supplementary information to assist residents.\n        ")]),_vm._v(" "),_c('div',{staticClass:"cardContent"},[_c('h3',[_vm._v(_vm._s(_vm.alert.title))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.alert.expected))])]),_vm._v(" "),(_vm.alert.saws_url || _vm.alert.ethekwini_url)?_c('div',{staticClass:"notices"},[_c('h3',[_vm._v("NOTICE"),(_vm.alert.saws_url && _vm.alert.ethekwini_url)?_c('span',[_vm._v("S")]):_vm._e(),_vm._v(":")]),_vm._v(" "),(_vm.alert.saws_url)?_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.openSource(_vm.alert.saws_url)}}},[_c('i',{staticClass:"icon-twitter"}),_vm._v(" SA Weather Service")]):_vm._e(),_vm._v(" "),(_vm.alert.ethekwini_url)?_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.openSource(_vm.alert.ethekwini_url)}}},[_c('i',{staticClass:"icon-twitter"}),_vm._v(" Ethekwini")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cardActions"},[(_vm.alert.type == 1)?_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.showAlertModal('rainModal')}}},[_vm._v("Safety Tips "),_c('i',{staticClass:"icon-right-open"})]):_vm._e(),_vm._v(" "),(_vm.alert.type == 2)?_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.showAlertModal('windModal')}}},[_vm._v("Safety Tips "),_c('i',{staticClass:"icon-right-open"})]):_vm._e(),_vm._v(" "),(_vm.alert.type == 3)?_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.showAlertModal('wavesModal')}}},[_vm._v("Safety Tips "),_c('i',{staticClass:"icon-right-open"})]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.$router.push({ path: _vm.alert.route })}}},[_vm._v("View Map "),_c('i',{staticClass:"icon-right-open"})]),_vm._v(" "),(_vm.tipsopen == true)?_c('div',{staticClass:"safetyTips"},[_c('ul')]):_vm._e()]),_vm._v(" "),(_vm.alert.type == 3)?_c('i',{staticClass:"alertIcon waves"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 234.38 204.72"}},[_c('title',[_vm._v("waves")]),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{attrs:{"d":"M233.5,194.89,178.18,99.08,122.86,3.27a6.55,6.55,0,0,0-11.34,0L56.2,99.08.89,194.89a6.55,6.55,0,0,0,5.67,9.83H227.82A6.55,6.55,0,0,0,233.5,194.89ZM158.39,167c-3.38,0-5.23,1.54-8,4s-6.46,6.45-12.6,6.45-9.84-4-12.6-6.45-4.61-4-8-4-5.22,1.54-8,4-6.45,6.45-12.6,6.45-9.83-3.68-12.6-6.14-4.61-4-8-4a5.34,5.34,0,0,1-4.92-5.22A5.06,5.06,0,0,1,76,157.14c6.76,0,11.37,4,14.45,6.76s4.61,4,6.14,4,2.77-1.23,5.84-4,7.69-6.76,14.45-6.76,11.37,4,14.44,6.76,4.61,4,6.15,4,2.77-1.23,5.84-4,7.68-6.76,14.44-6.76c3.08,0,5.54,2.46,5.54,4.92A5.28,5.28,0,0,1,158.39,167Zm0-24h-1.23a2.31,2.31,0,0,1-1.23.31c-.31,0-.61.31-.92.31-1.54.61-2.77,1.84-4.61,3.38-2.46,2.46-5.84,5.84-11.37,6.45H137.8c-4.61,0-8-2.46-10.45-4.61a14.52,14.52,0,0,0-2.15-2.15c-2.77-2.46-4.61-4-8-4H116a2.33,2.33,0,0,1-1.23.31c-.31,0-.62.31-.93.31-1.53.61-2.76,1.84-4.61,3.38-2.46,2.46-5.84,5.84-11.37,6.45H96.61c-6.14,0-9.83-4-12.6-6.45s-4.61-4-8-4a4.92,4.92,0,1,1,0-9.83c6.76,0,11.37,4,14.45,6.76,1.53,1.23,2.76,2.46,3.68,3.07a1.08,1.08,0,0,0,.62.31,4.33,4.33,0,0,0,1.84.62h.62c1.23,0,2.76-1.54,5.22-4.31,2.77-2.46,7.07-5.84,13.22-6.45h1.23c6.76,0,11.37,4,14.44,6.76a28.1,28.1,0,0,0,4.31,3.38,4.28,4.28,0,0,0,1.84.62h.61c1.54-.31,2.77-1.54,5.54-4s7.07-5.84,13.21-6.45h1.23a5.34,5.34,0,0,1,5.23,4.91A5.06,5.06,0,0,1,158.39,143Zm2.77-24.59c-.31.31-.62.62-.93.62a3.85,3.85,0,0,1-1.84.31h-1.23c-2.77.3-4.3,1.84-6.76,4-2.46,2.46-5.84,5.84-11.37,6.46H137.8c-4.61,0-8-2.46-10.45-4.62-.93-.61-1.54-1.53-2.15-1.84-2.77-2.46-4.61-4-8-4H116c-2.77.3-4.31,1.84-6.77,4-2.46,2.46-5.84,5.84-11.37,6.46H96.61c-6.14,0-9.83-4-12.6-6.46s-4.61-4-8-4a5,5,0,0,1-4.92-4.61c-.31-2.77,2.15-4.92,4.61-5.23h.62c6.76,0,11.37,3.69,14.44,6.45A24.29,24.29,0,0,0,94.46,119a4.29,4.29,0,0,0,.92.61,2.31,2.31,0,0,0,1.23.31h.62c1.53-.31,2.76-1.54,5.84-4,2.76-2.45,7.07-5.84,13.21-6.45h1.23c6.76,0,11.37,3.69,14.45,6.45l1.53,1.54a7.48,7.48,0,0,0,2.77,2.15,2.3,2.3,0,0,0,1.23.31h.61c1.54-.31,2.77-1.54,5.54-4,3.07-2.76,7.37-6.14,13.52-6.45h2.15c.31,0,.62.31.92.31s.62.3.93.61l.61.62a3.08,3.08,0,0,1,1.23,1.53,3.89,3.89,0,0,1,.31,1.85A5.28,5.28,0,0,1,161.16,118.41Z"}})])])])]):_vm._e(),_vm._v(" "),(_vm.alert.type == 2)?_c('i',{staticClass:"alertIcon winds"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 234.38 204.72"}},[_c('title',[_vm._v("wind")]),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{attrs:{"d":"M233.5,194.89,178.18,99.08,122.86,3.27a6.55,6.55,0,0,0-11.34,0L56.2,99.08.89,194.89a6.55,6.55,0,0,0,5.67,9.83H227.82A6.55,6.55,0,0,0,233.5,194.89ZM77.82,110.56h31.35a9.22,9.22,0,0,0,0-18.44,8.82,8.82,0,0,0-5.84,2.15c-1.54,1.23-2.15,3.38-2.15,6.15a4,4,0,0,1-8,0c0-5.23,1.53-9.22,4.61-12.3a16.48,16.48,0,0,1,11.68-4.61A16.82,16.82,0,0,1,126.38,101a17.18,17.18,0,0,1-17.21,17.21H77.82a4,4,0,0,1-4-3.68A4.07,4.07,0,0,1,77.82,110.56ZM143.59,176a17,17,0,0,1-11.37-4.61c-3.07-3.08-4.61-7.07-4.61-12.3a4,4,0,0,1,8,0c0,2.77.62,4.61,2.15,6.15a8.84,8.84,0,0,0,5.84,2.15,9.22,9.22,0,0,0,0-18.44H77.82a4,4,0,1,1,0-8H143.9a17.53,17.53,0,0,1-.31,35Zm0-41.8H77.82c-2.15,0-4-1.85-4-3.38a4.07,4.07,0,0,1,4-4h65.47a9.22,9.22,0,0,0,0-18.44,8.82,8.82,0,0,0-5.84,2.15c-1.54,1.23-2.16,3.38-2.16,6.15a4,4,0,0,1-8,0c0-5.23,1.54-9.22,4.61-12.3a16.9,16.9,0,0,1,11.68-4.61,17.22,17.22,0,0,1,0,34.43Z"}})])])])]):_vm._e(),_vm._v(" "),(_vm.alert.type == 1)?_c('i',{staticClass:"alertIcon rain"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 234.38 204.72"}},[_c('title',[_vm._v("rain")]),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{attrs:{"d":"M127.3,152.06l-10.45-17.83L106.1,153a.3.3,0,0,0-.31.31,14,14,0,0,0-1.54,6.14,12.66,12.66,0,0,0,12.6,12.6c7.07,0,12.91-5.53,12.91-12.29a12.25,12.25,0,0,0-2.15-7.38A.3.3,0,0,1,127.3,152.06Z"}}),_c('path',{attrs:{"d":"M91,119.48a.3.3,0,0,1-.31-.31l-4.3-7.68-4.61,8v.31a8.87,8.87,0,0,0-.62,2.76,5.51,5.51,0,0,0,5.53,5.53A5.08,5.08,0,0,0,92,122.55,6,6,0,0,0,91,119.48Z"}}),_c('path',{attrs:{"d":"M152.51,109.64l-6.46-11.06-6.76,11.68a.3.3,0,0,0-.31.3,9.55,9.55,0,0,0-.92,4,8.14,8.14,0,0,0,8,8,8.4,8.4,0,0,0,8.3-8,7.51,7.51,0,0,0-1.54-4.61A.3.3,0,0,1,152.51,109.64Z"}}),_c('path',{attrs:{"d":"M233.5,194.89,178.18,99.08,122.86,3.27a6.55,6.55,0,0,0-11.34,0L56.2,99.08.89,194.89a6.55,6.55,0,0,0,5.67,9.83H227.82A6.55,6.55,0,0,0,233.5,194.89ZM86.43,135.77a13.12,13.12,0,0,1-13.22-13.22,14.06,14.06,0,0,1,1.54-6.15.3.3,0,0,0,.31-.3l8-14.14a4.25,4.25,0,0,1,3.38-1.85A4.19,4.19,0,0,1,89.81,102l7.68,13.21a12.9,12.9,0,0,1,2.15,7.38A13.12,13.12,0,0,1,86.43,135.77Zm30.42,43.95a20.46,20.46,0,0,1-20.28-20.29A19.88,19.88,0,0,1,99,149.91v-.62l14.44-24.89a4.28,4.28,0,0,1,3.38-1.85,3.55,3.55,0,0,1,3.39,1.85l13.21,23.66a19.31,19.31,0,0,1,3.69,11.37A20.47,20.47,0,0,1,116.85,179.72Zm44.26-65.47a15.62,15.62,0,0,1-15.36,15.37,15.41,15.41,0,0,1-15.37-15.37,14.29,14.29,0,0,1,1.84-7.07l.31-.3,10.14-17.52a4,4,0,0,1,6.76,0L159,106A13.48,13.48,0,0,1,161.11,114.25Z"}})])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',[_c('span',[_vm._v("?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',{staticClass:"profileContainer",attrs:{"id":"profile"}},[_c('button',{staticClass:"btn backBtn",on:{"click":function($event){return _vm.$router.push({ path: '/' })}}},[_c('i',{staticClass:"icon-left-open"})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"cardHeader"},[_c('div',{staticClass:"cardHeader_details"},[_c('span',{staticClass:"cardHeader_name"},[_vm._v(_vm._s(_vm.user.name))]),_vm._v(" "),_c('span',{staticClass:"cardHeader_email"},[_vm._v(_vm._s(_vm.user.email))])]),_vm._v(" "),_c('button',{staticClass:"button cardHeader_button",on:{"click":_vm.logout}},[_vm._v("LOGOUT")])]),_vm._v(" "),_c('div',{staticClass:"cardBody region"},[_c('label',{staticClass:"label region_select-label",attrs:{"for":"region_select"}},[_vm._v("\n          Default Region:\n          "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.profile.weather_region_id),expression:"user.profile.weather_region_id"}],staticClass:"select region_select-option",attrs:{"id":"region_select"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.user.profile, "weather_region_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateProfile()}]}},_vm._l((_vm.regions),function(region){return _c('option',{key:region.id,domProps:{"value":region.id}},[_vm._v(_vm._s(region.name))])}),0)]),_vm._v(" "),_c('div',{staticClass:"select_container"},[_c('span',{staticClass:"select_container-label"},[_vm._v("Dark Mode")]),_vm._v(" "),_c('label',{staticClass:"switch"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.profile.dark_mode),expression:"user.profile.dark_mode"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.user.profile.dark_mode)?_vm._i(_vm.user.profile.dark_mode,null)>-1:(_vm.user.profile.dark_mode)},on:{"change":[function($event){var $$a=_vm.user.profile.dark_mode,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.user.profile, "dark_mode", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.user.profile, "dark_mode", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.user.profile, "dark_mode", $$c)}},function($event){return _vm.updateProfile()}]}}),_vm._v(" "),_c('span',{staticClass:"slider round"})])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"cardBody region"},[_c('div',{staticClass:"select_container"},[_c('span',{staticClass:"select_container-label"},[_vm._v("High Rainfall")]),_vm._v(" "),_c('label',{staticClass:"switch"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.profile.notification_high_rainfall),expression:"user.profile.notification_high_rainfall"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.user.profile.notification_high_rainfall)?_vm._i(_vm.user.profile.notification_high_rainfall,null)>-1:(_vm.user.profile.notification_high_rainfall)},on:{"change":[function($event){var $$a=_vm.user.profile.notification_high_rainfall,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.user.profile, "notification_high_rainfall", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.user.profile, "notification_high_rainfall", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.user.profile, "notification_high_rainfall", $$c)}},function($event){return _vm.updateProfile()}]}}),_vm._v(" "),_c('span',{staticClass:"slider round"})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"select_container"},[_c('span',{staticClass:"select_container-label"},[_vm._v("Daily Weather Update")]),_vm._v(" "),_c('label',{staticClass:"switch"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.profile.notification_daily_weather_update),expression:"user.profile.notification_daily_weather_update"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.user.profile.notification_daily_weather_update)?_vm._i(_vm.user.profile.notification_daily_weather_update,null)>-1:(_vm.user.profile.notification_daily_weather_update)},on:{"change":[function($event){var $$a=_vm.user.profile.notification_daily_weather_update,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.user.profile, "notification_daily_weather_update", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.user.profile, "notification_daily_weather_update", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.user.profile, "notification_daily_weather_update", $$c)}},function($event){return _vm.updateProfile()}]}}),_vm._v(" "),_c('span',{staticClass:"slider round"})])])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"cardBody region"},[_c('div',{staticClass:"select_container"},[_c('span',{staticClass:"select_container-label"},[_vm._v("Wind")]),_vm._v(" "),_c('div',{staticClass:"btnGroup"},[_c('button',{staticClass:"buttonGroupLeft",class:{ active: _vm.user.profile.unit_wind == 'km/h' },attrs:{"type":"button"},on:{"click":function($event){return _vm.updateUnitWind('km/h')}}},[_vm._v("km/h")]),_vm._v(" "),_c('button',{staticClass:"buttonGroupRight",class:{ active: _vm.user.profile.unit_wind == 'kn' },attrs:{"type":"button"},on:{"click":function($event){return _vm.updateUnitWind('kn')}}},[_vm._v("kn")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"select_container"},[_c('span',{staticClass:"select_container-label"},[_vm._v("Temperature")]),_vm._v(" "),_c('div',{staticClass:"btnGroup",attrs:{"id":"tempButtons"}},[_c('button',{staticClass:"buttonGroupLeft",class:{ active: _vm.user.profile.unit_temperature == 'C' },attrs:{"type":"button"},on:{"click":function($event){return _vm.updateUnitTemperature('C')}}},[_vm._v("℃")]),_vm._v(" "),_c('button',{staticClass:"buttonGroupRight",class:{ active: _vm.user.profile.unit_temperature == 'F' },attrs:{"type":"button"},on:{"click":function($event){return _vm.updateUnitTemperature('F')}}},[_vm._v("℉")])])])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('interest-card'),_vm._v(" "),_vm._m(4)],1)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iconContainer"},[_c('i',{staticClass:"icon-user"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cardHeader thin"},[_c('i',{staticClass:"icon-bell notificationIcon"}),_vm._v(" "),_c('h3',[_vm._v("NOTIFICATIONS")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cardHeader thin"},[_c('i',{staticClass:"icon-pencil notificationIcon"}),_vm._v(" "),_c('h3',[_vm._v("UNITS")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cardHeader thin"},[_c('i',{staticClass:"icon-user notificationIcon"}),_vm._v(" "),_c('h3',[_vm._v("INTERESTS")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('p',[_c('small',[_vm._v("The eThekwini Municipality will not be held responsible for any changes, omissions or inaccuracies contained herein which may result in unforeseen expense, injury or other misfortune.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cardsContain grid",attrs:{"id":"cardsContain"}},[(_vm.showinterests)?_c('interest-card'):_vm._e(),_vm._v(" "),_vm._l((_vm.alerts),function(alert){return _c('alert-card',{key:alert.id,staticClass:"card alertCard",class:alert.id,attrs:{"alert":alert}})}),_vm._v(" "),_vm._l((_vm.cardsData),function(card){return _c('HomeCardListItem',{key:card.id,attrs:{"card":card}})}),_vm._v(" "),_c('infinite-loading',{staticClass:"cardLoader",on:{"infinite":_vm.infiniteHandler}},[_c('div',{attrs:{"slot":"spinner"},slot:"spinner"},[_vm._v("Loading...")]),_vm._v(" "),_c('div',{attrs:{"slot":"no-more"},slot:"no-more"},[_vm._v("No further results.")]),_vm._v(" "),_c('div',{attrs:{"slot":"no-results"},slot:"no-results"},[_vm._v("No further results.")])]),_vm._v(" "),_c('profile-card')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeWeather_vue__ = __webpack_require__(295);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d1f6665_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeWeather_vue__ = __webpack_require__(438);
function injectStyle (ssrContext) {
  __webpack_require__(431)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeWeather_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d1f6665_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeWeather_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filterButtons",attrs:{"role":"group"}},[_c('button',{staticClass:"btn home",class:{ active: _vm.filter === 'all' },attrs:{"type":"button"},on:{"click":function($event){_vm.updateFilter ('all')}}},[_c('i',{staticClass:"icon-home"})]),_vm._v(" "),_c('button',{staticClass:"btn",class:{ active: _vm.filter === 'weather' },attrs:{"type":"button"},on:{"click":function($event){_vm.updateFilter ('weather')}}},[_vm._v("Weather")]),_vm._v(" "),_c('button',{staticClass:"btn",class:{ active: _vm.filter === 'news' },attrs:{"type":"button"},on:{"click":function($event){_vm.updateFilter ('news')}}},[_vm._v("News")]),_vm._v(" "),_c('button',{staticClass:"btn",class:{ active: _vm.filter === 'social' },attrs:{"type":"button"},on:{"click":function($event){_vm.updateFilter ('social')}}},[_vm._v("Social")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 434 */,
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeForecast_vue__ = __webpack_require__(298);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_825b9b28_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeForecast_vue__ = __webpack_require__(437);
function injectStyle (ssrContext) {
  __webpack_require__(436)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeForecast_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_825b9b28_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeForecast_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 436 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.forcasts),function(item,index){return _c('li',{key:index},[_vm._v("\n    "+_vm._s(_vm.calculateTemp(item.json_object.main.temp))),_c('sup',[_vm._v("°")]),_vm._v(_vm._s(_vm.tempType)+"\n    "),_c('i',[_c('img',{attrs:{"src":_vm.populateWeatherIcon(item.json_object.weather)}})]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.convertToBrowserTimeZone(item.timestamp)))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weather"},[(_vm.currentWeather)?_c('div',{staticClass:"summary"},[_c('i',{staticClass:"weatherIcon"},[_c('img',{attrs:{"src":_vm.populateWeatherIcon(_vm.currentWeather.json_object.weather)}})]),_vm._v(" "),_c('div',{staticClass:"weatherText"},[_c('h3',[_vm._v(_vm._s(_vm.currentWeather.json_object.weather[0].description))]),_vm._v(" "),_c('h1',[_vm._v("\n        "+_vm._s(_vm.calculateTemp)),_c('sup',[_vm._v("°"+_vm._s(_vm.tempType))]),_c('small',[_vm._v("in "+_vm._s(_vm.allWeather.name))])]),_vm._v(" "),_c('span',{staticClass:"scrolledDescriptionWrapper"},[_vm._v("\n          Humidity | "+_vm._s(_vm.currentWeather.json_object.main.humidity)+" %"),_c('br'),_vm._v("\n          Wind | "+_vm._s(_vm.calculateWind)+" "+_vm._s(_vm.windType)),_c('br'),_vm._v("\n          Pressure | "+_vm._s(_vm.currentWeather.json_object.main.pressure)+" hpa\n        ")]),_vm._v(" "),_c('div',{staticClass:"fullDescriptionWrapper"},[_vm._v("\n        Humidity "+_vm._s(_vm.currentWeather.json_object.main.humidity)+"%"),_c('br'),_vm._v("\n        Wind | "+_vm._s(_vm.calculateWind)+" "+_vm._s(_vm.windType)),_c('br'),_vm._v("\n        Pressure | "+_vm._s(_vm.currentWeather.json_object.main.pressure)+" hpa\n      ")])])]):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"forecast"},[_c('router-link',{staticClass:"btn viewMap",attrs:{"to":"/map"}},[_c('i',{staticClass:"icon-location"}),_vm._v(" View Map")]),_vm._v(" "),_c('a',{staticClass:"btn btnForecast float-right",on:{"click":function($event){return _vm.toggleForecast()}}},[_vm._v("Forecast "),_c('i',{staticClass:"icon-down-open"})]),_vm._v(" "),_c('transition',{attrs:{"name":"slide","mode":"out-in","duration":{ enter: 600, leave: 100 }}},[_c('home-forecast',{directives:[{name:"show",rawName:"v-show",value:(_vm.showForecast),expression:"showForecast"}],attrs:{"forcasts":_vm.allWeather.data,"tempType":_vm.tempType}})],1)],1),_vm._v(" "),_c('filter-buttons')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary weatherLoader",staticStyle:{"display":"none"}},[_c('i',{staticClass:"weatherIcon"},[_c('img',{attrs:{"src":"/static/img/weather/10d.svg"}})]),_vm._v(" "),_c('div',{staticClass:"weatherText"},[_c('h3',[_vm._v("LIGHT RAIN")]),_vm._v(" "),_c('h1',[_vm._v("\n        24"),_c('sup',[_vm._v("°C")]),_c('small',[_vm._v("in Pinetown")])]),_vm._v(" "),_c('span',{staticClass:"scrolledDescriptionWrapper"},[_vm._v("\n          Humidity | 100%"),_c('br'),_vm._v("\n          Wind | 14 km/h"),_c('br'),_vm._v("\n          Sea Level | 1017.95 hpa\n        ")]),_vm._v(" "),_c('div',{staticClass:"fullDescriptionWrapper"},[_vm._v("\n        Humidity | 100%"),_c('br'),_vm._v("\n        Wind | 14 km/h"),_c('br'),_vm._v("\n        Sea Level | 1017.95 hpa\n      ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",class:{'forecastShown':_vm.showForecast}},[_c('home-weather',{attrs:{"show-forecast":_vm.showForecast,"toggle-forecast":_vm.toggleForecast}}),_vm._v(" "),_c('div',{staticClass:"cards",attrs:{"id":"cards"},on:{"scroll":_vm.handleScroll}},[_c('home-card-list'),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_c('a',{staticClass:"btn btn-primary scrollTop",on:{"click":function($event){return _vm.scrollTop()}}},[_vm._v("Back to top")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('p',[_vm._v("PRODUCT OF ETHEKWINI MUNICIPALITY")]),_vm._v(" "),_c('a',{staticClass:"flickr",attrs:{"href":"http://flickr.com/","target":"_blank"}},[_c('i',{staticClass:"icon-flickr"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(299);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb36dbfc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(442);
function injectStyle (ssrContext) {
  __webpack_require__(441)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eb36dbfc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb36dbfc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login",class:{loading: _vm.loading},staticStyle:{"overflow-y":"scroll","width":"100%","height":"100%"}},[_c('router-view',{attrs:{"setloading":_vm.setLoading}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__(300);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_365d311d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__(445);
function injectStyle (ssrContext) {
  __webpack_require__(444)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-365d311d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_365d311d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signUpEmail",attrs:{"id":"register"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"loginForm"},[_c('h1',[_vm._v("REGISTER")]),_vm._v(" "),_c('div',{staticClass:"input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailform.name),expression:"emailform.name"}],attrs:{"type":"text","required":"","placeholder":"Name"},domProps:{"value":(_vm.emailform.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.emailform, "name", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"sr-only"},[_vm._v("Name")])]),_vm._v(" "),_c('div',{staticClass:"input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailform.email),expression:"emailform.email"}],attrs:{"type":"text","required":"","placeholder":"Email"},domProps:{"value":(_vm.emailform.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.emailform, "email", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"sr-only"},[_vm._v("Email")])]),_vm._v(" "),_c('div',{staticClass:"input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailform.password),expression:"emailform.password"}],staticClass:"password",attrs:{"type":"password","required":"","placeholder":"Password"},domProps:{"value":(_vm.emailform.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.emailform, "password", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"sr-only"},[_vm._v("Password")])]),_vm._v(" "),_c('button',{staticClass:"btn submitBtn",on:{"click":_vm.emailRegister}},[_vm._v("Register")])]),_vm._v(" "),_c('button',{staticClass:"btn backBtn",on:{"click":function($event){return _vm.$router.push({ path: '/login' })}}},[_c('i',{staticClass:"icon-left-open"}),_vm._v("Back to Login")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('p',[_vm._v("Register to customise your experience and manage your notifications.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(301);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53fd63bc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(448);
function injectStyle (ssrContext) {
  __webpack_require__(447)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53fd63bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53fd63bc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signUpSocial",attrs:{"id":"signUpSocial"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"buttons"},[_c('button',{staticClass:"btn google",on:{"click":_vm.googleLogin}},[_c('i',{staticClass:"icon-google"}),_vm._v("Continue with Google")]),_vm._v(" "),_c('button',{staticClass:"btn facebook",on:{"click":_vm.facebookLogin}},[_c('i',{staticClass:"icon-facebook"}),_vm._v("Continue with Facebook")]),_vm._v(" "),_c('button',{staticClass:"btn emailBtn",on:{"click":function($event){return _vm.$router.push({ path: '/login/email' })}}},[_c('i',{staticClass:"icon-mail"}),_vm._v("Sign In with Email")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn backBtn",on:{"click":function($event){return _vm.$router.push({ path: '/login/register' })}}},[_vm._v("Register a new Account with Email")]),_vm._v(" "),_c('a',{staticClass:"guest",on:{"click":function($event){return _vm.$router.push({ path: '/' })}}},[_vm._v("Continue as guest")])]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('p',[_vm._v("Sign in to customise your experience and manage your notifications.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('p',[_c('small',[_vm._v("The eThekwini Municipality will not be held responsible for any changes, omissions or inaccuracies contained herein which may result in unforeseen expense, injury or other misfortune.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__(302);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18f8e6eb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__(451);
function injectStyle (ssrContext) {
  __webpack_require__(450)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18f8e6eb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18f8e6eb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resetPassword",class:{ loading: _vm.loading },attrs:{"id":"reset"}},[_vm._m(0),_vm._v(" "),(!_vm.sent)?_c('div',{staticClass:"loginForm"},[_c('h1',[_vm._v("Reset Password")]),_vm._v(" "),_c('div',{staticClass:"input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"text","required":"","placeholder":"Email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"sr-only"},[_vm._v("Email")])]),_vm._v(" "),_c('button',{staticClass:"btn submitBtn",class:{ loading: _vm.loading },on:{"click":_vm.resetAccount}},[_vm._v("Reset")])]):_vm._e(),_vm._v(" "),(_vm.sent)?_c('div',{staticClass:"loginForm"},[_c('h1',[_vm._v("Reset Password Token")]),_vm._v(" "),_c('div',{staticClass:"input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.token),expression:"token"}],attrs:{"type":"text","required":"","placeholder":"Token"},domProps:{"value":(_vm.token)},on:{"input":function($event){if($event.target.composing){ return; }_vm.token=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"sr-only"},[_vm._v("Token")])]),_vm._v(" "),_c('div',{staticClass:"input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","required":"","placeholder":"Password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"sr-only"},[_vm._v("Password")])]),_vm._v(" "),_c('div',{staticClass:"input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password_confirm),expression:"password_confirm"}],attrs:{"type":"password","required":"","placeholder":"Password Confirm"},domProps:{"value":(_vm.password_confirm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password_confirm=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"sr-only"},[_vm._v("Confirm Password")])]),_vm._v(" "),_c('button',{staticClass:"btn submitBtn",class:{ loading: _vm.loading },on:{"click":_vm.resetWithToken}},[_vm._v("Update")])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn backBtn",on:{"click":function($event){return _vm.$router.push({ path: '/login' })}}},[_c('i',{staticClass:"icon-left-open"}),_vm._v("Back to Login")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('p')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailLogin_vue__ = __webpack_require__(303);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6215197c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailLogin_vue__ = __webpack_require__(454);
function injectStyle (ssrContext) {
  __webpack_require__(453)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6215197c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6215197c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signUpEmail",attrs:{"id":"signUpEmail"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"loginForm"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailform.email),expression:"emailform.email"}],attrs:{"type":"text","required":"","placeholder":"Email Address"},domProps:{"value":(_vm.emailform.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.emailform, "email", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"sr-only"},[_vm._v("Email")])]),_vm._v(" "),_c('div',{staticClass:"input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailform.password),expression:"emailform.password"}],staticClass:"password",attrs:{"type":"password","required":"","placeholder":"Password"},domProps:{"value":(_vm.emailform.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.emailform, "password", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"sr-only"},[_vm._v("Password")])]),_vm._v(" "),_c('button',{staticClass:"btn submitBtn",on:{"click":_vm.emailLogin}},[_vm._v("Sign In")]),_vm._v(" "),_c('a',{staticClass:"btn link",on:{"click":function($event){return _vm.$router.push({ path: '/login/reset'})}}},[_vm._v("Forgot Password")])]),_vm._v(" "),_c('button',{staticClass:"btn backToSocial",on:{"click":function($event){return _vm.$router.push({ path: '/login/' })}}},[_c('i',{staticClass:"icon-left-open"}),_vm._v("Back to Login")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('p',[_vm._v("Sign in to customise your experience and manage your notifications.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loginFormText"},[_c('i',{staticClass:"mail"}),_vm._v("Sign in with an email address")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleLogin_vue__ = __webpack_require__(304);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_076ce2f8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleLogin_vue__ = __webpack_require__(457);
function injectStyle (ssrContext) {
  __webpack_require__(456)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-076ce2f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_076ce2f8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 456 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FacebookLogin_vue__ = __webpack_require__(305);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7f8c0f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FacebookLogin_vue__ = __webpack_require__(460);
function injectStyle (ssrContext) {
  __webpack_require__(459)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d7f8c0f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FacebookLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7f8c0f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FacebookLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 459 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report_vue__ = __webpack_require__(306);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7414c4e1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Report_vue__ = __webpack_require__(463);
function injectStyle (ssrContext) {
  __webpack_require__(462)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7414c4e1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7414c4e1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report",attrs:{"id":"report"}},[_c('div',{staticClass:"card"},[_c('button',{staticClass:"btn backBtn",on:{"click":function($event){return _vm.$router.push({ path: '/' })}}},[_c('i',{staticClass:"icon-left-open"})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cardHeader"},[_c('span',{staticClass:"mainHeader"},[_vm._v("CONTACT LIST "),_c('small',[_vm._v("ETHEKWINI MUNICIPALITY")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cardBody"},[_c('table',{staticClass:"emergencyNumbers"},[_c('tbody',[_c('tr',[_c('td',[_c('h3',[_vm._v("AIDS HELP LINE")])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"tel:0800012322"}},[_vm._v("0800 012 322")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("AMBULANCE (PUBLIC)")])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"tel:10177"}},[_vm._v("10177")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("AMBULANCE (PRIVATE)")])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"tel:082911"}},[_vm._v("082 911")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("AIR POLLUTION")]),_vm._v(" "),_c('p',[_vm._v("Operating Hours "),_c('br'),_vm._v("8:00-16:00 Mon - Fri"),_c('br'),_vm._v(" After Hours contact Emergency Services ")])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"tel:0313113122"}},[_vm._v("031 311 3122")]),_vm._v(" "),_c('br'),_c('br'),_c('a',{attrs:{"href":"tel:0313610000"}},[_vm._v("031 361 0000")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("BEACHES AND RECREATION FACILITIES")]),_vm._v(" "),_c('p',[_vm._v("Operating Hours 7:30 - 18:00")])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"tel:031 322 4350"}},[_vm._v("031 322 4350")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("DEVELOPMENT PLANNING")]),_vm._v(" "),_c('p',[_vm._v("Operating Hours "),_c('br'),_vm._v("7:00-16: 30 Mon - Fri "),_c('br'),_vm._v("Sub Division "),_c('br'),_vm._v("Rezoning "),_c('br'),_vm._v("Special Consent")])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"tel:0313117883"}},[_vm._v("031 311 7883")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("DEVELOPMENT MANAGEMENT")]),_vm._v(" "),_c('p',[_vm._v("Building Inspectorate "),_c('br'),_vm._v(" Plans Submissions"),_c('br'),_vm._v(" Enforcement")])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"tel:0313117881"}},[_vm._v("031 311 7881")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("ADVERTISING AND SIGNAGE")])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"tel:0313117055"}},[_vm._v("031 311 7055")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("ENVIRONMENT")])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"tel:0313117875"}},[_vm._v("031 311 7875")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("ENGINEERING SERVICES CENTRE")]),_vm._v(" "),_c('p',[_vm._v("Operating Hours 24 Hours,\n                  "),_c('br'),_vm._v(" 7 Days a week:\n                  "),_c('br'),_vm._v("Road repairs\n                  "),_c('br'),_vm._v("Stormwater Blockages/Repairs \n                  "),_c('br'),_vm._v("Replacement of manhole covers \n                  "),_c('br'),_vm._v("Repairs of guardrails and \n                  "),_c('br'),_vm._v("roadside fencing \n                  "),_c('br'),_vm._v("Sidewalk and Kerb repairs \n                  "),_c('br'),_vm._v("Sewer Repairs/ Blockages \n                  "),_c('br'),_vm._v("Road Marking and Street Signs \n                  "),_c('br'),_vm._v("Water Reconnections / Accounts \n                  "),_c('br'),_vm._v("Faulty Traffic Signal \n                  "),_c('br'),_vm._v("Flooding Coastal Infrastructure \n                  "),_c('br'),_vm._v("Water faults \n                  "),_c('br'),_vm._v("Water Pollution \n                  "),_c('br'),_vm._v("Water Account Queries\n                  "),_c('br'),_vm._v("Whatsapp: \n                  "),_c('br'),_vm._v("SMS No.:\n                  "),_c('br'),_vm._v("Fax No.:\n                  "),_c('br'),_vm._v("Email : "),_c('a',{attrs:{"href":"mailto:eservices@dmws.durban.gov.za"}},[_vm._v("eservices@dmws.durban.gov.za")])])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"tel:0801313013"}},[_vm._v("080 131 3013")]),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://api.whatsapp.com/send?phone=270731483477","target":"_blank"}},[_c('i',{staticClass:"icon-whatsapp"}),_vm._v(" 073 148 3477")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"sms:0837073013"}},[_vm._v("083 707 3013")]),_c('br'),_c('a',{attrs:{"href":"tel:0313118220"}},[_vm._v("031 311 8220")]),_c('br')])]),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("ETHEKWINI REVENUE CALL CENTRE")])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"tel:0313245000"}},[_vm._v("031 324 5000")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("WATER FAULTS CALL CENTRE")]),_vm._v(" "),_c('p',[_vm._v("Operating Hours "),_c('br'),_vm._v("7:00-16: 30 Mon - Fri "),_c('br'),_vm._v("Sub Division "),_c('br'),_vm._v("Rezoning "),_c('br'),_vm._v("Special Consent")])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"tel:0801313013"}},[_vm._v("080 131 3013")])])])])]),_vm._v(" "),_c('table',{staticClass:"emergencyNumbers"},[_c('tbody',[_c('tr',[_c('td',[_c('h3',[_vm._v("ELECTRICITY FAULTS CALL CENTRE")]),_vm._v(" "),_c('p',[_vm._v("Operating Hours\n                  "),_c('br'),_vm._v("7:30 -16:30 Mon - Fri\n                  "),_c('br'),_vm._v("and 7:30 - 11:30 on Sat \n                  "),_c('br'),_vm._v("Rates \n                  "),_c('br'),_vm._v("Electricity \n                  "),_c('br'),_vm._v("Water Accounts\n                ")])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"tel:0801313111"}},[_vm._v("080 131 3111")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("EMERGENCY SERVICES:")]),_vm._v(" "),_c('p',[_vm._v("Operating 24 Hours, 7 Days a week:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Fire")]),_vm._v(" "),_c('li',[_vm._v("Disaster Management")]),_vm._v(" "),_c('li',[_vm._v("Metro Police")])])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"tel:0313610000"}},[_vm._v("031 361 0000")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("ELECTRICITY CALL CENTRE")]),_vm._v(" "),_c('p',[_vm._v("Operating Hours 24 Hours,\n                  "),_c('br'),_vm._v("7 Days a week: \n                  "),_c('br'),_vm._v("Electricity Faults and Breakdowns  \n                  "),_c('br'),_vm._v("Street Lights \n                  "),_c('br'),_vm._v("Illegal Connections \n                  "),_c('br'),_vm._v("Cable Theft ")])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"tel:0801313111"}},[_vm._v("080 13 13 111")]),_c('br'),_c('br'),_c('br'),_c('br'),_c('a',{attrs:{"href":"tel:0313119611"}},[_vm._v("031 311 9611")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("HEALTH")]),_vm._v(" "),_c('p',[_vm._v("Operating Hours 7:00-16:30 Mon to Fri\n                  "),_c('br'),_vm._v("After Hours contact Emergency Services\n                  "),_c('br'),_vm._v("Air Pollution \n                  "),_c('br'),_vm._v("Environmental Noise \n                  "),_c('br'),_vm._v("Illegal Dumping \n                  "),_c('br'),_vm._v("Food Safety \n                  "),_c('br'),_vm._v("Communicable Diseases \n                  "),_c('br'),_vm._v("Hazardous Chemical Substances\n                  "),_c('br'),_vm._v("Vector Control (Mosquitoes,Flies,rats,etc)")])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"tel:0313113555"}},[_vm._v("031 311 3555")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("ILLEGAL DUMPING")]),_vm._v(" "),_c('p',[_vm._v("Operating Hours 7:30-16:00 Mon to Fri")])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"tel:0313031665"}},[_vm._v("031 303 1665")]),_c('br'),_c('a',{attrs:{"href":"tel:0313118804"}},[_vm._v("031 311 8804")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("REFUSE REMOVAL")]),_vm._v(" "),_c('p',[_vm._v("Operating Hours 7:30-16:00 Mon to Fri\n                  "),_c('br'),_vm._v("Removal of dead animals")])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"tel:0313118804"}},[_vm._v("031 311 8804")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("PARKS, LEISURE AND CEMETERIES")]),_vm._v(" "),_c('p',[_vm._v("Operating Hours 7:30-16:00 Mon to Fri\n                  "),_c('br'),_vm._v("Verge and grass maintenance \n                  "),_c('br'),_vm._v("Fallen and Trimming of trees after Hours")])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"tel:0313224000"}},[_vm._v("031 322 4000")]),_c('br'),_c('a',{attrs:{"href":"tel:0313610000"}},[_vm._v("031 361 0000")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("OMBUDSPERSON AND HEAD INVESTIGATIONS")]),_vm._v(" "),_c('p',[_vm._v("Operating Hours 8:00-16:00 Mon to Fri\n                  "),_c('br'),_vm._v("Reporting Incidents within Municipality of:\n                  "),_c('br'),_vm._v("Fraud and Corruption \n                  "),_c('br'),_vm._v("Maladministration \n                  "),_c('br'),_c('a',{attrs:{"href":"maito:ombudsperson@durban.gov.za"}},[_vm._v("ombudsperson@durban.gov.za")])])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"tel:0800202020"}},[_vm._v("080 020 2020")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("REGIONAL CENTRES (SIZAKALA)")]),_vm._v(" "),_c('p',[_vm._v("Operating Hours 7:30 - 16:00 Mon to Fri\n                  "),_c('br'),_vm._v("One Stop Shops access/payments for council services\n                ")]),_vm._v(" "),_c('h3',[_vm._v("SWITCHBOARD")]),_vm._v(" "),_c('p',[_vm._v("Operating Hours 7:30-17:00, Mon - Fri")])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"tel:0800331011"}},[_vm._v("080 033 1011")]),_c('br'),_c('a',{attrs:{"href":"tel:0313116101"}},[_vm._v("031 311 6101")]),_c('br'),_c('br'),_c('a',{attrs:{"href":"tel:0313111111"}},[_vm._v("031 311 1111")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__ = __webpack_require__(307);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d7d9f45_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__ = __webpack_require__(509);
function injectStyle (ssrContext) {
  __webpack_require__(465)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d7d9f45_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 466 */,
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LIdwLeaflet_vue__ = __webpack_require__(308);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LIdwLeaflet_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LWaveLeaflet_vue__ = __webpack_require__(311);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LWaveLeaflet_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Waves;
/*  Global class for simulating the movement of particle through a 1km wind grid

 credit: All the credit for this work goes to: https://github.com/cambecc for creating the repo:
 https://github.com/cambecc/earth. The majority of this code is directly take nfrom there, since its awesome.

 This class takes a canvas element and an array of data (1km GFS from http://www.emc.ncep.noaa.gov/index.php?branch=GFS)
 and then uses a mercator (forward/reverse) projection to correctly map wind vectors in "map space".

 The "start" method takes the bounds of the map at its current extent and starts the whole gridding,
 interpolation and animation process.
 */
function Waves(params) {
  var MIN_VELOCITY_INTENSITY = params.minVelocity; // velocity at which particle intensity is minimum (m/s)
  var MAX_VELOCITY_INTENSITY = params.maxVelocity; // velocity at which particle intensity is maximum (m/s)
  var VELOCITY_SCALE = params.velocityScale * (Math.pow(window.devicePixelRatio, 1 / 3) || 1); // scale for wind velocity (completely arbitrary--this value looks nice)
  var MAX_PARTICLE_AGE = 90; // max number of frames a particle is drawn before regeneration
  var PARTICLE_LINE_WIDTH = params.particleWidth; // line width of a drawn particle
  var PARTICLE_MULTIPLIER = 1 / 1600; // particle count scalar (completely arbitrary--this values looks nice)
  var PARTICLE_REDUCTION = Math.pow(window.devicePixelRatio, 1 / 3) || 1.6; // multiply particle count for mobiles by this amount
  var FRAME_RATE = 40;
  var FRAME_TIME = 1000 / FRAME_RATE; // desired frames per second

  var defaulColorScale = ['rgb(36,104, 180)', 'rgb(60,157, 194)', 'rgb(128,205,193 )', 'rgb(151,218,168 )', 'rgb(198,231,181)', 'rgb(238,247,217)', 'rgb(255,238,159)', 'rgb(252,217,125)', 'rgb(255,182,100)', 'rgb(252,150,75)', 'rgb(250,112,52)', 'rgb(245,64,32)', 'rgb(237,45,28)', 'rgb(220,24,32)', 'rgb(180,0,35)'];

  var colorScale = params.colorScale || defaulColorScale;

  var NULL_WIND_VECTOR = [NaN, NaN, null]; // singleton for no wind in the form: [u, v, magnitude]

  var builder = null;
  var grid = [];
  var gridData = params.data;
  var date = void 0;
  var λ0 = void 0;
  var φ0 = void 0;
  var Δλ = void 0;
  var Δφ = void 0;
  var ni = void 0;
  var nj = void 0;

  var setData = function setData(data) {
    gridData = data;
  };

  // interpolation for vectors like wind (u,v,m)
  var bilinearInterpolateVector = function bilinearInterpolateVector(x, y, g00, g10, g01, g11) {
    var count = 0;
    if (g00[2] === 0) {
      count++;
    }
    if (g10[2] === 0) {
      count++;
    }
    if (g01[2] === 0) {
      count++;
    }
    if (g11[2] === 0) {
      count++;
    }

    var rx = 1 - x;
    var ry = 1 - y;
    var a = rx * ry;
    var b = x * ry;
    var c = rx * y;
    var d = x * y;
    var u = g00[0] * a + g10[0] * b + g01[0] * c + g11[0] * d;
    var v = g00[1] * a + g10[1] * b + g01[1] * c + g11[1] * d;
    var height = g00[2] * a + g10[2] * b + g01[2] * c + g11[2] * d;
    var period = g00[3] * a + g10[3] * b + g01[3] * c + g11[3] * d;
    if (count > 1) {
      return [0, 0, 0, 0, 0];
    }
    return [u, v, Math.sqrt(u * u + v * v), height, period];
  };

  var createWaveBuilder = function createWaveBuilder(data) {
    var uData = [];
    var vData = [];
    var height = [];
    var period = [];

    data[2].data.forEach(function (direction, index) {
      if (direction !== -9) {
        if (direction < 90 && direction > 0) {
          uData.push(-3 * Math.sin(Math.PI / 180 * direction));
          vData.push(-3 * Math.cos(Math.PI / 180 * direction));
        } else if (direction > 90 && direction < 180) {
          uData.push(-3 * Math.cos(Math.PI / 180 * (direction - 90)));
          vData.push(3 * Math.sin(Math.PI / 180 * (direction - 90)));
        } else if (direction > 180 && direction < 270) {
          uData.push(3 * Math.cos(Math.PI / 180 * (270 - direction)));
          vData.push(3 * Math.sin(Math.PI / 180 * (270 - direction)));
        } else if (direction > 270 && direction < 360) {
          uData.push(3 * Math.cos(Math.PI / 180 * (direction - 270)));
          vData.push(-3 * Math.sin(Math.PI / 180 * (direction - 270)));
        }

        height.push(data[0].data[index]);
        period.push(data[1].data[index]);
      } else {
        vData.push(0);
        uData.push(0);
        height.push(0);
        period.push(0);
      }
    });

    return {
      header: data[2].header,
      data: function data(i) {
        return [uData[i], vData[i], height[i], period[i]];
      },
      interpolate: bilinearInterpolateVector
    };
  };

  var createBuilder = function createBuilder(data) {
    return createWaveBuilder(data);
  };

  var buildGrid = function buildGrid(data, callback) {
    builder = createBuilder(data);
    var header = builder.header;

    λ0 = header.lo1;
    φ0 = header.la1; // the grid's origin (e.g., 0.0E, 90.0N)

    Δλ = header.dx;
    Δφ = header.dy; // distance between grid points (e.g., 2.5 deg lon, 2.5 deg lat)

    ni = header.nx;
    nj = header.ny; // number of grid points W-E and N-S (e.g., 144 x 73)
    date = new Date(header.refTime);

    // Scan mode 0 assumed. Longitude increases from λ0, and latitude decreases from φ0.
    // http://www.nco.ncep.noaa.gov/pmb/docs/grib2/grib2_table3-4.shtml
    grid = [];
    var p = 0;
    var isContinuous = Math.floor(ni * Δλ) >= 360;

    for (var j = 0; j < nj; j++) {
      var row = [];
      for (var i = 0; i < ni; i++, p++) {
        row[i] = builder.data(p);
      }
      if (isContinuous) {
        // For wrapped grids, duplicate first column as last column to simplify interpolation logic
        row.push(row[0]);
      }
      grid[j] = row;
    }
    var callbackdata = {
      date: date,
      interpolate: interpolate
    };
    callback(callbackdata);
  };

  /**
   * Get interpolated grid value from Lon/Lat position
   * @param λ {Float} Longitude
   * @param φ {Float} Latitude
   * @returns {Object}
   */
  var interpolate = function interpolate(λ, φ) {
    if (!grid) return null;

    var i = floorMod(λ - λ0, 360) / Δλ; // calculate longitude index in wrapped range [0, 360)
    var j = (φ0 - φ) / Δφ; // calculate latitude index in direction +90 to -90
    var fi = Math.floor(i);
    var ci = fi + 1;
    var fj = Math.floor(j);
    var cj = fj + 1;
    var row = grid[fj];
    if (!row) {
      return null;
    }
    var g00 = row[fi];
    var g10 = row[ci];
    row = grid[cj];
    if (!row) {
      return null;
    }
    if (isValue(g00) && isValue(g10)) {
      var g01 = row[fi];
      var g11 = row[ci];
      if (isValue(g01) && isValue(g11)) {
        // All four points found, so interpolate the value.
        return builder.interpolate(i - fi, j - fj, g00, g10, g01, g11);
      }
    }
    return null;
  };

  /**
   * @returns {Boolean} true if the specified value is not null and not undefined.
   */
  var isValue = function isValue(x) {
    return x !== null && x !== undefined;
  };

  /**
   * @returns {Number} returns remainder of floored division, i.e., floor(a / n). Useful for consistent modulo
   *          of negative numbers. See http://en.wikipedia.org/wiki/Modulo_operation.
   */
  var floorMod = function floorMod(a, n) {
    return a - n * Math.floor(a / n);
  };

  /**
   * @returns {Boolean} true if agent is probably a mobile device. Don't really care if this is accurate.
   */
  var isMobile = function isMobile() {
    return (/android|blackberry|iemobile|ipad|iphone|ipod|opera mini|webos/i.test(navigator.userAgent)
    );
  };

  /**
   * Calculate distortion of the wind vector caused by the shape of the projection at point (x, y). The wind
   * vector is modified in place and returned by this function.
   */
  var distort = function distort(projection, λ, φ, x, y, scale, wind, wave) {
    var u = wind[0] * scale;
    var v = wind[1] * scale;
    var d = distortion(projection, λ, φ, x, y, wave);

    // Scale distortion vectors by u and v, then add.
    wind[0] = d[0] * u + d[2] * v;
    wind[1] = d[1] * u + d[3] * v;
    return wind;
  };

  var distortion = function distortion(projection, λ, φ, x, y, wave) {
    var τ = 2 * Math.PI;
    var H = Math.pow(10, -5.2);
    var hλ = λ < 0 ? H : -H;
    var hφ = φ < 0 ? H : -H;

    var pλ = project(φ, λ + hλ, wave);
    var pφ = project(φ + hφ, λ, wave);

    // Meridian scale factor (see Snyder, equation 4-3), where R = 1. This handles issue where length of 1º λ
    // changes depending on φ. Without this, there is a pinching effect at the poles.
    var k = Math.cos(φ / 360 * τ);
    return [(pλ[0] - x) / hλ / k, (pλ[1] - y) / hλ / k, (pφ[0] - x) / hφ, (pφ[1] - y) / hφ];
  };

  var createField = function createField(columns, bounds, callback) {
    /**
     * @returns {Array} wind vector [u, v, magnitude] at the point (x, y), or [NaN, NaN, null] if wind
     *          is undefined at that point.
     */
    function field(x, y) {
      var column = columns[Math.round(x)];
      return column && column[Math.round(y)] || NULL_WIND_VECTOR;
    }

    // Frees the massive 'columns' array for GC. Without this, the array is leaked (in Chrome) each time a new
    // field is interpolated because the field closure's context is leaked, for reasons that defy explanation.
    field.release = function () {
      columns = [];
    };

    field.randomize = function (o) {
      // UNDONE: this method is terrible
      var x = void 0,
          y = void 0;
      var safetyNet = 0;
      do {
        x = Math.round(Math.floor(Math.random() * bounds.width) + bounds.x);
        y = Math.round(Math.floor(Math.random() * bounds.height) + bounds.y);
      } while (field(x, y)[2] === null && safetyNet++ < 30);
      o.x = x;
      o.y = y;
      return o;
    };

    callback(bounds, field);
  };

  var buildBounds = function buildBounds(bounds, width, height) {
    var upperLeft = bounds[0];
    var lowerRight = bounds[1];
    var x = Math.round(upperLeft[0]); // Math.max(Math.floor(upperLeft[0], 0), 0)
    var y = Math.max(Math.floor(upperLeft[1], 0), 0);
    // let xMax = Math.min(Math.ceil(lowerRight[0], width), width - 1)
    var yMax = Math.min(Math.ceil(lowerRight[1], height), height - 1);
    return {
      x: x,
      y: y,
      xMax: width,
      yMax: yMax,
      width: width,
      height: height
    };
  };

  var deg2rad = function deg2rad(deg) {
    return deg / 180 * Math.PI;
  };

  var rad2deg = function rad2deg(ang) {
    return ang / (Math.PI / 180.0);
  };

  var invert = function invert(x, y, wave) {
    var mapLonDelta = wave.east - wave.west;
    var worldMapRadius = wave.width / rad2deg(mapLonDelta) * 360 / (2 * Math.PI);
    var mapOffsetY = worldMapRadius / 2 * Math.log((1 + Math.sin(wave.south)) / (1 - Math.sin(wave.south)));
    var equatorY = wave.height + mapOffsetY;
    var a = (equatorY - y) / worldMapRadius;

    var lat = 180 / Math.PI * (2 * Math.atan(Math.exp(a)) - Math.PI / 2);
    var lon = rad2deg(wave.west) + x / wave.width * rad2deg(mapLonDelta);
    return [lon, lat];
  };

  var mercY = function mercY(lat) {
    return Math.log(Math.tan(lat / 2 + Math.PI / 4));
  };

  var project = function project(lat, lon, wave) {
    // both in radians, use deg2rad if neccessary
    var ymin = mercY(wave.south);
    var ymax = mercY(wave.north);
    var xFactor = wave.width / (wave.east - wave.west);
    var yFactor = wave.height / (ymax - ymin);

    var y = mercY(deg2rad(lat));
    var x = (deg2rad(lon) - wave.west) * xFactor;
    y = (ymax - y) * yFactor; // y points south
    return [x, y];
  };

  var interpolateField = function interpolateField(grid, bounds, extent, callback) {
    var projection = {};
    var mapArea = (extent.south - extent.north) * (extent.west - extent.east);
    var velocityScale = VELOCITY_SCALE * Math.pow(mapArea, 0.4);

    var columns = [];
    var x = bounds.x;

    function interpolateColumn(x) {
      var column = [];
      for (var y = bounds.y; y <= bounds.yMax; y += 2) {
        var coord = invert(x, y, extent);
        if (coord) {
          var λ = coord[0];
          var φ = coord[1];
          if (isFinite(λ)) {
            var wind = grid.interpolate(λ, φ);
            if (wind) {
              wind = distort(projection, λ, φ, x, y, velocityScale, wind, extent);
              column[y + 1] = column[y] = wind;
            }
          }
        }
      }
      columns[x + 1] = columns[x] = column;
    }

    (function batchInterpolate() {
      var start = Date.now();
      while (x < bounds.width) {
        interpolateColumn(x);
        x += 2;
        if (Date.now() - start > 1000) {
          // MAX_TASK_TIME) {
          setTimeout(batchInterpolate, 25);
          return;
        }
      }
      createField(columns, bounds, callback);
    })();
  };

  var animationLoop = void 0;
  var animate = function animate(bounds, field) {
    function windIntensityColorScale(min, max) {
      colorScale.indexFor = function (m) {
        // map velocity speed to a style
        return Math.max(0, Math.min(colorScale.length - 1, Math.round((m - min) / (max - min) * (colorScale.length - 1))));
      };

      return colorScale;
    }

    var colorStyles = windIntensityColorScale(MIN_VELOCITY_INTENSITY, MAX_VELOCITY_INTENSITY);
    var buckets = colorStyles.map(function () {
      return [];
    });

    var particleCount = Math.round(bounds.width * bounds.height * PARTICLE_MULTIPLIER);
    if (isMobile()) {
      particleCount *= PARTICLE_REDUCTION;
    }

    var fadeFillStyle = 'rgba(0, 0, 0, 0.97)';

    var particles = [];
    for (var i = 0; i < particleCount; i++) {
      particles.push(field.randomize({
        age: Math.floor(Math.random() * MAX_PARTICLE_AGE) + 0
      }));
    }

    function evolve() {
      buckets.forEach(function (bucket) {
        bucket.length = 0;
      });
      particles.forEach(function (particle) {
        if (particle.age > MAX_PARTICLE_AGE) {
          field.randomize(particle).age = 0;
        }
        var x = particle.x;
        var y = particle.y;
        var v = field(x, y); // vector at current position
        var m = v[3];
        if (m === null) {
          particle.age = MAX_PARTICLE_AGE; // particle has escaped the grid, never to return...
        } else {
          var xt = x + v[0];
          var yt = y + v[1];
          if (field(xt, yt)[2] !== null) {
            // Path from (x,y) to (xt,yt) is visible, so add this particle to the appropriate draw bucket.
            particle.xt = xt;
            particle.yt = yt;
            buckets[colorStyles.indexFor(m)].push(particle);
          } else {
            // Particle isn't visible, but it still moves through the field.
            particle.x = xt;
            particle.y = yt;
          }
        }
        particle.age += 1;
      });
    }

    var g = params.canvas.getContext('2d');
    g.lineWidth = PARTICLE_LINE_WIDTH;
    g.fillStyle = fadeFillStyle;
    g.globalAlpha = 0.6;

    function draw() {
      // Fade existing particle trails.
      var prev = 'lighter';
      g.globalCompositeOperation = 'destination-in';
      g.fillRect(bounds.x, bounds.y, bounds.width, bounds.height);
      g.globalCompositeOperation = prev;
      g.globalAlpha = 0.9;

      // Draw new particle trails.
      buckets.forEach(function (bucket, i) {
        if (bucket.length > 0) {
          g.beginPath();
          g.strokeStyle = colorStyles[i];
          bucket.forEach(function (particle) {
            g.moveTo(particle.x, particle.y);
            g.lineTo(particle.xt, particle.yt);
            particle.x = particle.xt;
            particle.y = particle.yt;
          });
          g.stroke();
        }
      });
    }
    var then = Date.now();
    (function frame() {
      animationLoop = requestAnimationFrame(frame);
      var now = Date.now();
      var delta = now - then;
      if (delta > FRAME_TIME) {
        then = now - delta % FRAME_TIME;
        evolve();
        draw();
      }
    })();
  };

  var start = function start(bounds, width, height, extent) {
    var mapBounds = {
      south: deg2rad(extent[0][1]),
      north: deg2rad(extent[1][1]),
      east: deg2rad(extent[1][0]),
      west: deg2rad(extent[0][0]),
      width: width,
      height: height
    };

    stop();

    // build grid
    buildGrid(gridData, function (grid) {
      // interpolateField
      interpolateField(grid, buildBounds(bounds, width, height), mapBounds, function (bounds, field) {
        // animate the canvas with random points
        wave.field = field;
        animate(bounds, field);
      });
    });
  };

  var stop = function stop() {
    if (wave.field) wave.field.release();
    if (animationLoop) cancelAnimationFrame(animationLoop);
  };

  var wave = {
    params: params,
    start: start,
    stop: stop,
    createField: createField,
    interpolatePoint: interpolate,
    setData: setData
  };

  return wave;
}

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LVectorLeaflet_vue__ = __webpack_require__(312);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LVectorLeaflet_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Windy;
/*  Global class for simulating the movement of particle through a 1km wind grid

 credit: All the credit for this work goes to: https://github.com/cambecc for creating the repo:
 https://github.com/cambecc/earth. The majority of this code is directly take nfrom there, since its awesome.

 This class takes a canvas element and an array of data (1km GFS from http://www.emc.ncep.noaa.gov/index.php?branch=GFS)
 and then uses a mercator (forward/reverse) projection to correctly map wind vectors in "map space".

 The "start" method takes the bounds of the map at its current extent and starts the whole gridding,
 interpolation and animation process.
 */
function Windy(params) {
  var MIN_VELOCITY_INTENSITY = params.minVelocity; // velocity at which particle intensity is minimum (m/s)
  var MAX_VELOCITY_INTENSITY = params.maxVelocity; // velocity at which particle intensity is maximum (m/s)
  var VELOCITY_SCALE = params.velocityScale * (Math.pow(window.devicePixelRatio, 1 / 3) || 1); // scale for wind velocity (completely arbitrary--this value looks nice)
  var MAX_PARTICLE_AGE = 120; // max number of frames a particle is drawn before regeneration
  var PARTICLE_LINE_WIDTH = params.particleWidth; // line width of a drawn particle
  var PARTICLE_MULTIPLIER = 1 / 600; // particle count scalar (completely arbitrary-this values looks nice)
  var PARTICLE_REDUCTION = Math.pow(window.devicePixelRatio, 1 / 3) || 1.6; // multiply particle count for mobiles by this amount
  var FRAME_RATE = 15;
  var FRAME_TIME = 1000 / FRAME_RATE; // desired frames per second

  var defaulColorScale = ['rgb(36,104, 180)', 'rgb(60,157, 194)', 'rgb(128,205,193 )', 'rgb(151,218,168 )', 'rgb(198,231,181)', 'rgb(238,247,217)', 'rgb(255,238,159)', 'rgb(252,217,125)', 'rgb(255,182,100)', 'rgb(252,150,75)', 'rgb(250,112,52)', 'rgb(245,64,32)', 'rgb(237,45,28)', 'rgb(220,24,32)', 'rgb(180,0,35)'];

  var colorScale = params.colorScale || defaulColorScale;

  var NULL_WIND_VECTOR = [NaN, NaN, null]; // singleton for no wind in the form: [u, v, magnitude]

  var builder = null;
  var grid = [];
  var gridData = params.data;
  var date = void 0;
  var λ0 = void 0;
  var φ0 = void 0;
  var Δλ = void 0;
  var Δφ = void 0;
  var ni = void 0;
  var nj = void 0;

  var setData = function setData(data) {
    gridData = data;
  };

  // interpolation for vectors like wind (u,v,m)
  var bilinearInterpolateVector = function bilinearInterpolateVector(x, y, g00, g10, g01, g11) {
    var rx = 1 - x;
    var ry = 1 - y;
    var a = rx * ry;
    var b = x * ry;
    var c = rx * y;
    var d = x * y;
    var u = g00[0] * a + g10[0] * b + g01[0] * c + g11[0] * d;
    var v = g00[1] * a + g10[1] * b + g01[1] * c + g11[1] * d;
    return [u, v, Math.sqrt(u * u + v * v)];
  };

  var createWindBuilder = function createWindBuilder(uComp, vComp) {
    var uData = uComp.data;
    var vData = vComp.data;
    return {
      header: uComp.header,
      // recipe: recipeFor('wind-' + uComp.header.surface1Value),
      data: function data(i) {
        return [uData[i], vData[i]];
      },
      interpolate: bilinearInterpolateVector
    };
  };

  var createBuilder = function createBuilder(data) {
    var uComp = data[0];
    var vComp = data[1];

    return createWindBuilder(uComp, vComp);
  };

  var buildGrid = function buildGrid(data, callback) {
    builder = createBuilder(data);
    var header = builder.header;

    λ0 = header.lo1;
    φ0 = header.la1; // the grid's origin (e.g., 0.0E, 90.0N)

    Δλ = header.dx;
    Δφ = header.dy; // distance between grid points (e.g., 2.5 deg lon, 2.5 deg lat)

    ni = header.nx;
    nj = header.ny; // number of grid points W-E and N-S (e.g., 144 x 73)
    date = new Date(header.refTime);

    // Scan mode 0 assumed. Longitude increases from λ0, and latitude decreases from φ0.
    // http://www.nco.ncep.noaa.gov/pmb/docs/grib2/grib2_table3-4.shtml
    grid = [];
    var p = 0;
    var isContinuous = Math.floor(ni * Δλ) >= 360;
    for (var j = 0; j < nj; j++) {
      var row = [];
      for (var i = 0; i < ni; i++, p++) {
        row[i] = builder.data(p);
      }
      if (isContinuous) {
        // For wrapped grids, duplicate first column as last column to simplify interpolation logic
        row.push(row[0]);
      }
      grid[j] = row;
    }
    var callbackdata = {
      date: date,
      interpolate: interpolate
    };
    callback(callbackdata);
  };

  /**
   * Get interpolated grid value from Lon/Lat position
   * @param λ {Float} Longitude
   * @param φ {Float} Latitude
   * @returns {Object}
   */
  var interpolate = function interpolate(λ, φ) {
    if (!grid) return null;

    var i = floorMod(λ - λ0, 360) / Δλ; // calculate longitude index in wrapped range [0, 360)
    var j = (φ0 - φ) / Δφ; // calculate latitude index in direction +90 to -90
    var fi = Math.floor(i);
    var ci = fi + 1;
    var fj = Math.floor(j);
    var cj = fj + 1;
    var row = grid[fj];
    if (!row) {
      return null;
    }
    var g00 = row[fi];
    var g10 = row[ci];
    row = grid[cj];
    if (!row) {
      return null;
    }
    if (isValue(g00) && isValue(g10)) {
      var g01 = row[fi];
      var g11 = row[ci];
      if (isValue(g01) && isValue(g11)) {
        // All four points found, so interpolate the value.
        return builder.interpolate(i - fi, j - fj, g00, g10, g01, g11);
      }
    }
    return null;
  };

  /**
   * @returns {Boolean} true if the specified value is not null and not undefined.
   */
  var isValue = function isValue(x) {
    return x !== null && x !== undefined;
  };

  /**
   * @returns {Number} returns remainder of floored division, i.e., floor(a / n). Useful for consistent modulo
   *          of negative numbers. See http://en.wikipedia.org/wiki/Modulo_operation.
   */
  var floorMod = function floorMod(a, n) {
    return a - n * Math.floor(a / n);
  };

  /**
   * @returns {Boolean} true if agent is probably a mobile device. Don't really care if this is accurate.
   */
  var isMobile = function isMobile() {
    return (/android|blackberry|iemobile|ipad|iphone|ipod|opera mini|webos/i.test(navigator.userAgent)
    );
  };

  /**
   * Calculate distortion of the wind vector caused by the shape of the projection at point (x, y). The wind
   * vector is modified in place and returned by this function.
   */
  var distort = function distort(projection, λ, φ, x, y, scale, wind, windy) {
    var u = wind[0] * scale;
    var v = wind[1] * scale;
    var d = distortion(projection, λ, φ, x, y, windy);

    // Scale distortion vectors by u and v, then add.
    wind[0] = d[0] * u + d[2] * v;
    wind[1] = d[1] * u + d[3] * v;
    return wind;
  };

  var distortion = function distortion(projection, λ, φ, x, y, windy) {
    var τ = 2 * Math.PI;
    var H = Math.pow(10, -5.2);
    var hλ = λ < 0 ? H : -H;
    var hφ = φ < 0 ? H : -H;

    var pλ = project(φ, λ + hλ, windy);
    var pφ = project(φ + hφ, λ, windy);

    // Meridian scale factor (see Snyder, equation 4-3), where R = 1. This handles issue where length of 1º λ
    // changes depending on φ. Without this, there is a pinching effect at the poles.
    var k = Math.cos(φ / 360 * τ);
    return [(pλ[0] - x) / hλ / k, (pλ[1] - y) / hλ / k, (pφ[0] - x) / hφ, (pφ[1] - y) / hφ];
  };

  var createField = function createField(columns, bounds, callback) {
    /**
     * @returns {Array} wind vector [u, v, magnitude] at the point (x, y), or [NaN, NaN, null] if wind
     *          is undefined at that point.
     */
    function field(x, y) {
      var column = columns[Math.round(x)];
      return column && column[Math.round(y)] || NULL_WIND_VECTOR;
    }

    // Frees the massive 'columns' array for GC. Without this, the array is leaked (in Chrome) each time a new
    // field is interpolated because the field closure's context is leaked, for reasons that defy explanation.
    field.release = function () {
      columns = [];
    };

    field.randomize = function (o) {
      // UNDONE: this method is terrible
      var x = void 0,
          y = void 0;
      var safetyNet = 0;
      do {
        x = Math.round(Math.floor(Math.random() * bounds.width) + bounds.x);
        y = Math.round(Math.floor(Math.random() * bounds.height) + bounds.y);
      } while (field(x, y)[2] === null && safetyNet++ < 30);
      o.x = x;
      o.y = y;
      return o;
    };

    callback(bounds, field);
  };

  var buildBounds = function buildBounds(bounds, width, height) {
    var upperLeft = bounds[0];
    var lowerRight = bounds[1];
    var x = Math.round(upperLeft[0]); // Math.max(Math.floor(upperLeft[0], 0), 0)
    var y = Math.max(Math.floor(upperLeft[1], 0), 0);
    // let xMax = Math.min(Math.ceil(lowerRight[0], width), width - 1)
    var yMax = Math.min(Math.ceil(lowerRight[1], height), height - 1);
    return {
      x: x,
      y: y,
      xMax: width,
      yMax: yMax,
      width: width,
      height: height
    };
  };

  var deg2rad = function deg2rad(deg) {
    return deg / 180 * Math.PI;
  };

  var rad2deg = function rad2deg(ang) {
    return ang / (Math.PI / 180.0);
  };

  var invert = function invert(x, y, windy) {
    var mapLonDelta = windy.east - windy.west;
    var worldMapRadius = windy.width / rad2deg(mapLonDelta) * 360 / (2 * Math.PI);
    var mapOffsetY = worldMapRadius / 2 * Math.log((1 + Math.sin(windy.south)) / (1 - Math.sin(windy.south)));
    var equatorY = windy.height + mapOffsetY;
    var a = (equatorY - y) / worldMapRadius;

    var lat = 180 / Math.PI * (2 * Math.atan(Math.exp(a)) - Math.PI / 2);
    var lon = rad2deg(windy.west) + x / windy.width * rad2deg(mapLonDelta);
    return [lon, lat];
  };

  var mercY = function mercY(lat) {
    return Math.log(Math.tan(lat / 2 + Math.PI / 4));
  };

  var project = function project(lat, lon, windy) {
    // both in radians, use deg2rad if neccessary
    var ymin = mercY(windy.south);
    var ymax = mercY(windy.north);
    var xFactor = windy.width / (windy.east - windy.west);
    var yFactor = windy.height / (ymax - ymin);

    var y = mercY(deg2rad(lat));
    var x = (deg2rad(lon) - windy.west) * xFactor;
    y = (ymax - y) * yFactor; // y points south
    return [x, y];
  };

  var interpolateField = function interpolateField(grid, bounds, extent, callback) {
    var projection = {};
    var mapArea = (extent.south - extent.north) * (extent.west - extent.east);
    var velocityScale = VELOCITY_SCALE * Math.pow(mapArea, 0.4);

    var columns = [];
    var x = bounds.x;

    function interpolateColumn(x) {
      var column = [];
      for (var y = bounds.y; y <= bounds.yMax; y += 2) {
        var coord = invert(x, y, extent);
        if (coord) {
          var λ = coord[0];
          var φ = coord[1];
          if (isFinite(λ)) {
            var wind = grid.interpolate(λ, φ);
            if (wind) {
              wind = distort(projection, λ, φ, x, y, velocityScale, wind, extent);
              column[y + 1] = column[y] = wind;
            }
          }
        }
      }
      columns[x + 1] = columns[x] = column;
    }

    (function batchInterpolate() {
      var start = Date.now();
      while (x < bounds.width) {
        interpolateColumn(x);
        x += 2;
        if (Date.now() - start > 1000) {
          // MAX_TASK_TIME) {
          setTimeout(batchInterpolate, 25);
          return;
        }
      }
      createField(columns, bounds, callback);
    })();
  };

  var animationLoop = void 0;
  var animate = function animate(bounds, field) {
    function windIntensityColorScale(min, max) {
      colorScale.indexFor = function (m) {
        // map velocity speed to a style
        return Math.max(0, Math.min(colorScale.length - 1, Math.round((m - min) / (max - min) * (colorScale.length - 1))));
      };

      return colorScale;
    }

    var colorStyles = windIntensityColorScale(MIN_VELOCITY_INTENSITY, MAX_VELOCITY_INTENSITY);
    var buckets = colorStyles.map(function () {
      return [];
    });

    var particleCount = Math.round(bounds.width * bounds.height * PARTICLE_MULTIPLIER);
    if (isMobile()) {
      particleCount *= PARTICLE_REDUCTION;
    }

    var fadeFillStyle = 'rgba(0, 0, 0, 0.97)';

    var particles = [];
    for (var i = 0; i < particleCount; i++) {
      particles.push(field.randomize({
        age: Math.floor(Math.random() * MAX_PARTICLE_AGE) + 0
      }));
    }

    function evolve() {
      buckets.forEach(function (bucket) {
        bucket.length = 0;
      });
      particles.forEach(function (particle) {
        if (particle.age > MAX_PARTICLE_AGE) {
          field.randomize(particle).age = 0;
        }
        var x = particle.x;
        var y = particle.y;
        var v = field(x, y); // vector at current position
        var m = v[2];
        if (m === null) {
          particle.age = MAX_PARTICLE_AGE; // particle has escaped the grid, never to return...
        } else {
          var xt = x + v[0];
          var yt = y + v[1];
          if (field(xt, yt)[2] !== null) {
            // Path from (x,y) to (xt,yt) is visible, so add this particle to the appropriate draw bucket.
            particle.xt = xt;
            particle.yt = yt;
            buckets[colorStyles.indexFor(m)].push(particle);
          } else {
            // Particle isn't visible, but it still moves through the field.
            particle.x = xt;
            particle.y = yt;
          }
        }
        particle.age += 1;
      });
    }

    var g = params.canvas.getContext('2d');
    g.lineWidth = PARTICLE_LINE_WIDTH;
    g.fillStyle = fadeFillStyle;
    g.globalAlpha = 0.6;

    function draw() {
      // Fade existing particle trails.
      var prev = 'lighter';
      g.globalCompositeOperation = 'destination-in';
      g.fillRect(bounds.x, bounds.y, bounds.width, bounds.height);
      g.globalCompositeOperation = prev;
      g.globalAlpha = 0.9;

      // Draw new particle trails.
      buckets.forEach(function (bucket, i) {
        if (bucket.length > 0) {
          g.beginPath();
          g.strokeStyle = colorStyles[i];
          bucket.forEach(function (particle) {
            g.moveTo(particle.x, particle.y);
            g.lineTo(particle.xt, particle.yt);
            particle.x = particle.xt;
            particle.y = particle.yt;
          });
          g.stroke();
        }
      });
    }
    var then = Date.now();
    (function frame() {
      animationLoop = requestAnimationFrame(frame);
      var now = Date.now();
      var delta = now - then;
      if (delta > FRAME_TIME) {
        then = now - delta % FRAME_TIME;
        evolve();
        draw();
      }
    })();
  };

  var start = function start(bounds, width, height, extent) {
    var mapBounds = {
      south: deg2rad(extent[0][1]),
      north: deg2rad(extent[1][1]),
      east: deg2rad(extent[1][0]),
      west: deg2rad(extent[0][0]),
      width: width,
      height: height
    };

    stop();

    // build grid
    buildGrid(gridData, function (grid) {
      // interpolateField
      interpolateField(grid, buildBounds(bounds, width, height), mapBounds, function (bounds, field) {
        // animate the canvas with random points
        windy.field = field;
        animate(bounds, field);
      });
    });
  };

  var stop = function stop() {
    if (windy.field) windy.field.release();
    if (animationLoop) cancelAnimationFrame(animationLoop);
  };

  var windy = {
    params: params,
    start: start,
    stop: stop,
    createField: createField,
    interpolatePoint: interpolate,
    setData: setData
  };

  return windy;
}

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CamsView_vue__ = __webpack_require__(313);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c0685a9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CamsView_vue__ = __webpack_require__(490);
function injectStyle (ssrContext) {
  __webpack_require__(489)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c0685a9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CamsView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c0685a9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CamsView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cams",attrs:{"id":"cams"}},[(_vm.selectedCam.name)?_c('div',{staticClass:"camWrap",on:{"click":_vm.clearCam}},[_c('div',{staticClass:"camsView"},[_c('img',{staticClass:"photo",attrs:{"src":_vm.storageUrl + 'cameras/' + _vm.selectedCam.name + '.jpg',"alt":""}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"camsViewGallery"},_vm._l((_vm.cams),function(cam){return _c('div',{key:cam.name,on:{"click":function($event){return _vm.changeCam(cam)}}},[_c('img',{staticClass:"photo",attrs:{"src":_vm.storageUrl + 'cameras/' + cam.name + '-thumb.jpg',"alt":""}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(cam.name))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map",attrs:{"id":"map"}},[_c('div',{staticClass:"mapFilters",attrs:{"role":"group"}},[_c('button',{staticClass:"btn backBtn",on:{"click":function($event){return _vm.$router.push({ path: '/' })}}},[_c('i',{staticClass:"icon-left-open"})]),_vm._v(" "),_c('button',{staticClass:"btn",class:{ active: _vm.ui.currentView == 'wind' },attrs:{"type":"button"},on:{"click":function($event){return _vm.setView('wind')}}},[_vm._v("Wind")]),_vm._v(" "),_c('button',{staticClass:"btn",class:{ active: _vm.ui.currentView == 'rain' },attrs:{"type":"button"},on:{"click":function($event){return _vm.setView('rain')}}},[_vm._v("Rain")]),_vm._v(" "),_c('button',{staticClass:"btn",class:{ active: _vm.ui.currentView == 'waves' },attrs:{"type":"button"},on:{"click":function($event){return _vm.setView('waves')}}},[_vm._v("Waves")]),_vm._v(" "),_c('button',{staticClass:"btn",class:{ active: _vm.ui.currentView == 'cams' },attrs:{"type":"button"},on:{"click":function($event){return _vm.setView('cams')}}},[_vm._v("Cams")])]),_vm._v(" "),(_vm.ui.currentView == 'wind')?_c('div',{staticClass:"meter windMeter"},[(!_vm.user || _vm.user.profile.unit_wind === 'km/h')?_c('div',[_c('span',[_vm._v("Wind Speed")]),_vm._v(" "),_c('span',[_vm._v("km/h")]),_vm._v(" "),_c('span',[_vm._v("0")]),_vm._v(" "),_c('span',[_vm._v("20")]),_vm._v(" "),_c('span',[_vm._v("40")]),_vm._v(" "),_c('span',[_vm._v("60")]),_vm._v(" "),_c('span',[_vm._v("80")]),_vm._v(" "),_c('span',[_vm._v("100")])]):_c('div',[_c('span',[_vm._v("Wind Speed")]),_vm._v(" "),_c('span',[_vm._v("knots")]),_vm._v(" "),_c('span',[_vm._v("0")]),_vm._v(" "),_c('span',[_vm._v("12")]),_vm._v(" "),_c('span',[_vm._v("23")]),_vm._v(" "),_c('span',[_vm._v("35")]),_vm._v(" "),_c('span',[_vm._v("46")]),_vm._v(" "),_c('span',[_vm._v("58")])])]):_vm._e(),_vm._v(" "),(_vm.ui.currentView == 'rain')?_c('div',{staticClass:"meter rainMeter"},[_c('span',[_vm._v("Rain")]),_vm._v(" "),_c('span',[_vm._v("mm/3hr")]),_vm._v(" "),_c('span',[_vm._v("0")]),_vm._v(" "),_c('span',[_vm._v("6")]),_vm._v(" "),_c('span',[_vm._v("12")]),_vm._v(" "),_c('span',[_vm._v("18")]),_vm._v(" "),_c('span',[_vm._v("24")]),_vm._v(" "),_c('span',[_vm._v("30")])]):_vm._e(),_vm._v(" "),(_vm.ui.currentView == 'waves')?_c('div',{staticClass:"meter waveMeter"},[_c('span',[_vm._v("Wave Height")]),_vm._v(" "),_c('span',[_vm._v("m")]),_vm._v(" "),_c('span',[_vm._v("0")]),_vm._v(" "),_c('span',[_vm._v("2")]),_vm._v(" "),_c('span',[_vm._v("4")]),_vm._v(" "),_c('span',[_vm._v("6")]),_vm._v(" "),_c('span',[_vm._v("8")]),_vm._v(" "),_c('span',[_vm._v("10")])]):_vm._e(),_vm._v(" "),_c('l-map',{attrs:{"zoom":_vm.zoom,"minZoom":3,"center":_vm.center},on:{"update:center":_vm.centerUpdate,"update:zoom":_vm.zoomUpdate}},[_c('l-tile-layer',{attrs:{"url":_vm.url,"attribution":_vm.attribution}}),_vm._v(" "),(_vm.ui.currentView == 'rain')?_c('l-idw-layer',{attrs:{"geojson":_vm.rainfall.data,"options":_vm.rainfall.options}}):_vm._e(),_vm._v(" "),(_vm.ui.currentView == 'wind')?_c('l-vector-layer',{attrs:{"geojson":_vm.wind.data,"options":_vm.wind.options}}):_vm._e(),_vm._v(" "),(_vm.ui.currentView == 'waves')?_c('l-wave-layer',{attrs:{"geojson":_vm.wave.data,"options":_vm.wave.options}}):_vm._e(),_vm._v(" "),_vm._l((_vm.cams),function(cam){return (_vm.ui.currentView == 'cams')?_c('l-marker',{key:cam.name,attrs:{"icon":_vm.camicon,"lat-lng":[cam.latitude, cam.longitude]},on:{"click":function($event){return _vm.clickCamera(cam)}}}):_vm._e()}),_vm._v(" "),(_vm.userpin.lat)?_c('l-marker',{attrs:{"icon":_vm.usericon,"lat-lng":[_vm.userpin.lat, _vm.userpin.long]}}):_vm._e()],2),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('transition',{attrs:{"name":"slide","mode":"out-in"}},[(_vm.ui.currentView == 'cams' && _vm.selectedCamera)?_c('cams-view',{attrs:{"selectedCam":_vm.selectedCamera,"changeCam":_vm.clickCamera}}):_vm._e()],1),_vm._v(" "),(_vm.ui.currentView == 'rain'|| _vm.ui.currentView == 'wind' || _vm.ui.currentView == 'waves')?_c('div',{staticClass:"rangeScrubber",class:{loading: _vm.rainfall.loading}},[_c('div',{staticClass:"dateRange"},[(!_vm.rainfall.loading)?_c('span',[_vm._v(_vm._s(_vm.currentTimeStamp))]):_vm._e(),_vm._v(" "),(_vm.rainfall.loading)?_c('span',[_vm._v("Loading...")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.timeline.currentDate),expression:"timeline.currentDate"}],attrs:{"type":"range","min":_vm.timeline.startDate,"max":_vm.timeline.endDate,"step":"10800"},domProps:{"value":(_vm.timeline.currentDate)},on:{"__r":function($event){return _vm.$set(_vm.timeline, "currentDate", $event.target.value)}}}),_vm._v(" "),_c('a',{on:{"click":_vm.toggleTimelineContinuous}},[(!_vm.timeline.continuous)?_c('i',{staticClass:"icon-right-open-big"}):_vm._e(),_vm._v(" "),(_vm.timeline.continuous)?_c('i',{staticClass:"pauseIcon"},[_vm._v("||")]):_vm._e()])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legend"},[_c('span')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(322);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53dbbe8a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(512);
function injectStyle (ssrContext) {
  __webpack_require__(511)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53dbbe8a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile scrollable"},[_c('profile-card',{attrs:{"user":_vm.user,"regions":_vm.weatherRegions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Link_vue__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Link_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Link_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fee4be4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Link_vue__ = __webpack_require__(515);
function injectStyle (ssrContext) {
  __webpack_require__(514)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Link_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fee4be4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Link_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link"},[_c('div',{staticClass:"cardHeader"},[_c('button',{staticClass:"btn backBtn",on:{"click":function($event){return _vm.$router.push({ path: '/' })}}},[_c('i',{staticClass:"icon-left-open"})]),_vm._v(" "),_c('span',{staticClass:"mainHeader"},[_vm._v("COASTAL LIVE")])]),_vm._v(" "),_c('iframe',{attrs:{"src":"http://www.w3schools.com"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jwt_decode__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_persistedstate__ = __webpack_require__(520);




var _this = this;






__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);

var defaultState = {
  apiEndpoint: "https://coastallive-api.firstviewmedia.com/api/",
  storageEndpoint: "https://coastallive-api.firstviewmedia.com/storage/",
  notAuthUrls: ['auth/login', 'weather/regions', 'refresh'],
  jwt: localStorage.getItem('t'),
  user: null,
  weatherRegions: [],
  weather: [],
  cameras: [],
  cards: [],
  interests: [],
  filter: 'all',
  alert: null,
  showModal: false
};

var actions = {
  RegisterByEmail: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2, payload) {
      var commit = _ref2.commit,
          state = _ref2.state;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$axios.post('auth/signup', payload).then(function (response) {
                  commit('updateJWT', 'Bearer ' + response.data.token);
                  resolve(response);
                }).catch(function (error) {
                  // eslint-disable-next-line
                  console.error(error);
                  reject(error);
                });
              });

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function RegisterByEmail(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(),
  loginByEmail: function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4, payload) {
      var commit = _ref4.commit,
          state = _ref4.state;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$axios.post('auth/login', payload).then(function (response) {
                  commit('updateJWT', 'Bearer ' + response.data.token);
                  resolve(response);
                }).catch(function (error) {
                  // eslint-disable-next-line
                  console.error(error);
                  reject(error);
                });
              });

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function loginByEmail(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }(),
  refreshToken: function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref6) {
      var commit = _ref6.commit,
          state = _ref6.state;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$axios.get('refresh').then(function (response) {
                  commit('updateJWT', response.headers.authorization);
                  resolve(response);
                }).catch(function (error) {
                  // eslint-disable-next-line
                  console.error(error);
                  reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function refreshToken(_x5) {
      return _ref5.apply(this, arguments);
    };
  }(),
  getUserInfo: function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(_ref8) {
      var commit = _ref8.commit,
          state = _ref8.state;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$axios.get('auth/user').then(function (response) {
                  commit('USER_UPDATED', response.data);
                  resolve(response);
                }).catch(function (error) {
                  // eslint-disable-next-line
                  console.error(error);
                  reject(error);
                });
              });

            case 2:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function getUserInfo(_x6) {
      return _ref7.apply(this, arguments);
    };
  }(),
  updateUserInfo: function () {
    var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(_ref10, payload) {
      var commit = _ref10.commit,
          state = _ref10.state;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$axios.put('auth/user', payload).then(function (response) {
                  commit('USER_UPDATED', response.data);
                  resolve(response);
                }).catch(function (error) {
                  // eslint-disable-next-line
                  console.error(error);
                  reject(error);
                });
              });

            case 2:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));

    return function updateUserInfo(_x7, _x8) {
      return _ref9.apply(this, arguments);
    };
  }(),
  updateUserInterests: function () {
    var _ref11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(_ref12, payload) {
      var commit = _ref12.commit,
          state = _ref12.state;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$axios.put('auth/user-interest', payload).then(function (response) {
                  commit('USER_UPDATED', response.data);
                  resolve(response);
                }).catch(function (error) {
                  // eslint-disable-next-line
                  console.error(error);
                  reject(error);
                });
              });

            case 2:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this);
    }));

    return function updateUserInterests(_x9, _x10) {
      return _ref11.apply(this, arguments);
    };
  }(),
  getWeatherRegions: function () {
    var _ref13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(_ref14) {
      var commit = _ref14.commit,
          state = _ref14.state;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$axios.get('weather/regions').then(function (response) {
                  commit('WEATHER_REGIONS_UPDATED', response.data);
                  resolve(response);
                }).catch(function (error) {
                  // eslint-disable-next-line
                  console.error(error);
                  reject(error);
                });
              });

            case 2:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this);
    }));

    return function getWeatherRegions(_x11) {
      return _ref13.apply(this, arguments);
    };
  }(),
  getWeatherData: function () {
    var _ref15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(_ref16, id) {
      var commit = _ref16.commit,
          state = _ref16.state;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$axios.get('weather/regions/' + id).then(function (response) {
                  commit('WEATHER_UPDATED', response.data);
                  resolve(response);
                }).catch(function (error) {
                  // eslint-disable-next-line
                  console.error(error);
                  reject(error);
                });
              });

            case 2:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this);
    }));

    return function getWeatherData(_x12, _x13) {
      return _ref15.apply(this, arguments);
    };
  }(),
  getCards: function () {
    var _ref17 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(_ref18, page) {
      var commit = _ref18.commit,
          state = _ref18.state;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var url = page === 1 || page === undefined ? 'cards' : 'cards?page=' + page;
                return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$axios.get(url).then(function (response) {
                  commit('CARDS_UPDATED', response.data);
                  resolve(response);
                }).catch(function (error) {
                  // eslint-disable-next-line
                  console.error(error);
                  reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this);
    }));

    return function getCards(_x14, _x15) {
      return _ref17.apply(this, arguments);
    };
  }(),
  getInterests: function () {
    var _ref19 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(_ref20) {
      var commit = _ref20.commit,
          state = _ref20.state;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$axios.get('interests').then(function (response) {
                  commit('INTERESTS_UPDATED', response.data);
                  resolve(response);
                }).catch(function (error) {
                  // eslint-disable-next-line
                  console.error(error);
                  reject(error);
                });
              });

            case 2:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this);
    }));

    return function getInterests(_x16) {
      return _ref19.apply(this, arguments);
    };
  }(),
  getCameras: function () {
    var _ref21 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(_ref22) {
      var commit = _ref22.commit,
          state = _ref22.state;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$axios.get('cameras').then(function (response) {
                  commit('CAMERAS_UPDATED', response.data);
                  resolve(response);
                }).catch(function (error) {
                  // eslint-disable-next-line
                  console.error(error);
                  reject(error);
                });
              });

            case 2:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this);
    }));

    return function getCameras(_x17) {
      return _ref21.apply(this, arguments);
    };
  }(),
  getFacebookLoginUrl: function () {
    var _ref23 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(_ref24) {
      var commit = _ref24.commit,
          state = _ref24.state;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$axios.get('auth/login/facebook').then(function (response) {
                  console.log(response);
                  resolve(response);
                }).catch(function (error) {
                  reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this);
    }));

    return function getFacebookLoginUrl(_x18) {
      return _ref23.apply(this, arguments);
    };
  }(),
  resetByEmail: function () {
    var _ref25 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(_ref26, email) {
      var commit = _ref26.commit,
          state = _ref26.state;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$axios.post('auth/recovery', {
                  email: email
                }).then(function (response) {
                  console.log(response);
                  resolve(response);
                }).catch(function (error) {
                  reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this);
    }));

    return function resetByEmail(_x19, _x20) {
      return _ref25.apply(this, arguments);
    };
  }(),
  resetByToken: function () {
    var _ref27 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(_ref28, resetinfo) {
      var commit = _ref28.commit,
          state = _ref28.state;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$axios.post('auth/reset', {
                  email: resetinfo.email,
                  token: resetinfo.token,
                  password: resetinfo.password
                }).then(function (response) {
                  console.log(response);
                  resolve(response);
                }).catch(function (error) {
                  reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context14.stop();
          }
        }
      }, _callee14, _this);
    }));

    return function resetByToken(_x21, _x22) {
      return _ref27.apply(this, arguments);
    };
  }(),
  getFacebookLoginUser: function () {
    var _ref29 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(_ref30, code) {
      var commit = _ref30.commit,
          state = _ref30.state;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              return _context15.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$axios.get('auth/login/facebookUser?code=' + code).then(function (response) {
                  console.log(response);
                  commit('updateJWT', 'Bearer ' + response.data.token);
                  resolve(response);
                }).catch(function (error) {
                  reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context15.stop();
          }
        }
      }, _callee15, _this);
    }));

    return function getFacebookLoginUser(_x23, _x24) {
      return _ref29.apply(this, arguments);
    };
  }(),
  getGoogleLoginUrl: function () {
    var _ref31 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(_ref32) {
      var commit = _ref32.commit,
          state = _ref32.state;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              return _context16.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$axios.get('auth/login/google').then(function (response) {
                  console.log(response);
                  resolve(response);
                }).catch(function (error) {
                  reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context16.stop();
          }
        }
      }, _callee16, _this);
    }));

    return function getGoogleLoginUrl(_x25) {
      return _ref31.apply(this, arguments);
    };
  }(),
  getGoogleLoginUser: function () {
    var _ref33 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(_ref34, code) {
      var commit = _ref34.commit,
          state = _ref34.state;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              return _context17.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$axios.get('auth/login/googleUser?code=' + code).then(function (response) {
                  console.log(response);
                  commit('updateJWT', 'Bearer ' + response.data.token);
                  resolve(response);
                }).catch(function (error) {
                  reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context17.stop();
          }
        }
      }, _callee17, _this);
    }));

    return function getGoogleLoginUser(_x26, _x27) {
      return _ref33.apply(this, arguments);
    };
  }(),
  getAlert: function () {
    var _ref35 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(_ref36) {
      var commit = _ref36.commit,
          state = _ref36.state;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$axios.get('alert').then(function (response) {
                  if (response.status === 200) {
                    commit('ALERT_UPDATED', response.data);
                    console.log(response.data);
                  } else {
                    commit('ALERT_UPDATED', null);
                  }
                  resolve(response);
                }).catch(function (error) {
                  // eslint-disable-next-line
                  console.error(error);
                  reject(error);
                });
              });

            case 2:
            case 'end':
              return _context18.stop();
          }
        }
      }, _callee18, _this);
    }));

    return function getAlert(_x28) {
      return _ref35.apply(this, arguments);
    };
  }()
};

var mutations = {
  USER_UPDATED: function USER_UPDATED(state, user) {
    state.user = user;
  },
  WEATHER_REGIONS_UPDATED: function WEATHER_REGIONS_UPDATED(state, weatherRegions) {
    state.weatherRegions = weatherRegions;
  },
  WEATHER_UPDATED: function WEATHER_UPDATED(state, weather) {
    state.weather = weather;
  },
  CARDS_UPDATED: function CARDS_UPDATED(state, cards) {
    state.cards = cards;
  },
  INTERESTS_UPDATED: function INTERESTS_UPDATED(state, interests) {
    state.interests = interests;
  },
  CAMERAS_UPDATED: function CAMERAS_UPDATED(state, cameras) {
    state.cameras = cameras;
  },
  FILTER_UPDATED: function FILTER_UPDATED(state, filter) {
    state.filter = filter;
  },
  ALERT_UPDATED: function ALERT_UPDATED(state, alert) {
    state.alert = alert;
  },
  updateJWT: function updateJWT(state, newToken) {
    console.log('Update JWT');
    console.log(newToken);
    localStorage.setItem('t', newToken);
    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$axios.defaults.headers.common['Authorization'] = newToken;
    state.jwt = newToken;
  },
  removeJWT: function removeJWT(state) {
    localStorage.removeItem('t');
    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$axios.defaults.headers.common['Authorization'] = null;
    state.jwt = null;
    state.user = null;
    state.cards = [];
    state.interests = [];
  },
  updateUserData: function updateUserData(state) {
    actions.getUserInfo();
  }
};

var getters = {
  weather: function weather(state) {
    return state.weather;
  },
  weatherRegions: function weatherRegions(state) {
    return state.weatherRegions;
  },
  user: function user(state) {
    return state.user;
  },
  cards: function cards(state) {
    return state.cards;
  },
  cameras: function cameras(state) {
    return state.cameras;
  },
  interests: function interests(state) {
    return state.interests;
  },
  alert: function alert(state) {
    return state.alert;
  },
  filter: function filter(state) {
    return state.filter;
  },
  storageEndpoint: function storageEndpoint(state) {
    return state.storageEndpoint;
  },
  isTokenExpired: function isTokenExpired(state, getters) {
    var token = state.jwt;
    if (token) {
      var decoded = __WEBPACK_IMPORTED_MODULE_5_jwt_decode___default()(token);
      var now = Date.now();
      if (now / 1000 > decoded.iat + 628200) {
        // Todo: Redirect to login
        var response = {
          status: false,
          action: 'login'
        };
        return response;
      } else if (now / 1000 > decoded.exp) {
        return true;
      } else {
        return false;
      }
    }
  },
  isUserLoggedOut: function isUserLoggedOut(state, getters) {
    return !state.jwt;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */].Store({
  state: defaultState,
  getters: getters,
  actions: actions,
  mutations: mutations,
  plugins: [Object(__WEBPACK_IMPORTED_MODULE_6_vuex_persistedstate__["a" /* default */])()]
}));

/***/ }),
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
]),[354]);


// WEBPACK FOOTER //
// static/js/app.613821e42919e9c690e6.js